import {
    escapeHTML,
    hideMainMenuContent,
    makeGetRequest,
    monthNames, requestTimeout,
    runFuseElementsSearch
} from "./ui-helpers.js";
import {globals, globalUser} from "../modules/globals.js";
import {captureError, gameLimits, getRandomChoice, toTitleCase} from "../modules/helpers.js";
import {playSoundEffect} from "./sounds.js";
import {selectSuperstarTraitElement} from "./roster-sub-menu.js";
import {showScenarioEditorChampionshipGraphic, showScenarioEditorSuperstarGraphic} from "./graphics.js";
import {generateSuperstar} from "../modules/generate.js";

// Declare editor variables
let scenarioData;
let originalScenarioData;
let newScenarioObjectUid = 1;
let scenarioEditorInfoShown = false;

$(document).ready(function () {

    /* Load scenario buttons */

    // Edit scenario
    $("#container").on('click', '.edit-scenario', function () {
        let uid = $(this).parent('.scenario').attr('data-uid');
        let version = $(this).prevAll('.versions:first').find('#select-version').val();
        loadEditScenarioDataRequest(uid, version, 'scenario');
    });

    // Create edit
    $("#container").on('click', '.create-scenario-edit', function () {
        if ($(this).hasClass('disabled')) {
            return;
        }
        let uid = $(this).closest('.scenario').attr('data-uid');
        let version = $(this).closest('.scenario').find('.versions').find('#select-version').val();
        loadEditScenarioDataRequest(uid, version, 'scenario_edit');
    });

    // Edit scenario edit
    $("#new-game-menu").on('click', '.edit-scenario-edit', function (e) {
        e.stopPropagation();
        let parent = $(this).parent('.scenario-edit');
        let uid = parent.attr('data-uid');
        loadEditScenarioDataRequest(uid, null, 'scenario_edit');
    });

    // Duplicate scenario
    $("#container").on('click', '.duplicate-scenario-button', function () {
        let $this = $(this);
        notie.confirm({
            text: "Are you sure? This will create a new scenario.",
            submitCallback: function () {
                let uid = $this.parent('.scenario').attr('data-uid');
                let version = $this.prevAll('.versions:first').find('#select-version').val();
                loadEditScenarioDataRequest(uid, version, 'scenario', true);
            }
        });
    });

    /* Editor UI (left column) */

    // Continue to editor from info page
    $(".continue-to-scenario-editor-button").on('click', function () {
        playSoundEffect('success');
        hideMainMenuContent($());
        $('.scenario-editor-container').fadeIn('slow');
    });

    // Click main menu button
    $('.scenario-editor-main-menu-container .scenario-editor-menu-button').on('click', function () {

        // Don't run if item validation failed
        if (!checkScenarioEditorItemValidation()) {
            return false;
        }

        // Select this button
        $('.scenario-editor-menu-button.selected').removeClass('selected');
        $(this).addClass('selected');

        // Load scenario details for editing
        let itemType = $(this).attr('data-value');
        if (itemType === 'scenario-details') {
            loadScenarioEditorObjectForEditing(scenarioData['scenario_details'], itemType, scenarioData['companies'][0]);
        }
        else if (itemType === 'changes-made') {
            loadScenarioEditorChangesMadePage(scenarioData, originalScenarioData);
        }
    });

    // Click companies menu button
    $(document).on('click', '.scenario-editor-companies-menu-container .scenario-editor-menu-button', function () {

        if (!checkScenarioEditorItemValidation()) {
            return false;
        }

        // Set company uid / indies
        let selectedCompanyUid = ($(this).attr('data-uid')) ? ($(this).attr('data-uid')) : null;
        let indies = !!($(this).attr('data-indies'));
        $('.scenario-editor-container').data('companyUid', selectedCompanyUid);
        $('.scenario-editor-container').data('indies', indies);

        // Load company page
        let companyData = getScenarioEditorSelectedCompanyData(scenarioData);
        loadScenarioEditorCompanyPage(companyData);

    });

    // Click company/indies menu button
    $('.scenario-editor-company-menu-container .scenario-editor-menu-button, ' +
        '.scenario-editor-indies-menu-container .scenario-editor-menu-button').on('click', function () {

        if (!checkScenarioEditorItemValidation()) {
            return false;
        }

        // Select this button
        $('.scenario-editor-menu-button.selected').removeClass('selected');
        $(this).addClass('selected');

        // Load list page for company based on item type
        let itemType = $(this).attr('data-value');
        let companyData = getScenarioEditorSelectedCompanyData(scenarioData);
        if (itemType === 'company-details') {
            // Load company details for editing
            loadScenarioEditorObjectForEditing(companyData['company_details'], itemType, companyData);
        }
        else {
            loadScenarioEditorListPage(companyData, itemType);
        }

    });

    // Click back button
    $('.scenario-editor-back-button').on('click', function () {

        if (!checkScenarioEditorItemValidation()) {
            return false;
        }

        // Process open graphic
        processScenarioEditorItemGraphic();

        // Go back to previous page
        let previousPage = $('.scenario-editor-container').data('previousPage');
        if (previousPage === 'mainPage') {
            loadScenarioEditorMainPage(scenarioData);
        }
        else if (previousPage === 'companyPage') {
            let companyData = getScenarioEditorSelectedCompanyData(scenarioData);
            loadScenarioEditorCompanyPage(companyData);
        }

    });

    // Click back to main menu button
    $('.scenario-editor-main-menu-button').on('click', function () {
        if (!checkScenarioEditorItemValidation()) {
            return false;
        }
        // Process open graphic
        processScenarioEditorItemGraphic();

        loadScenarioEditorMainPage(scenarioData)
    });

    // Click list item
    $(document).on('click', '.scenario-editor-list-item', function () {

        // Don't run if disabled (empty results) or validation failed
        if ($(this).hasClass('disabled')) {
            return false;
        }
        if (!checkScenarioEditorItemValidation()) {
            return false;
        }

        // Process open graphic
        processScenarioEditorItemGraphic();

        // Select this list item
        $('.scenario-editor-list-item.selected').removeClass('selected');
        $(this).addClass('selected');

        // Get item object
        let itemUid = $(this).attr('data-uid');
        let itemType = $('.scenario-editor-menu-button.selected').attr('data-value');
        let companyData = getScenarioEditorSelectedCompanyData(scenarioData);
        let itemObjects = getScenarioEditorItemObjects(companyData, itemType);
        let itemObject = getScenarioEditorItemObject(itemObjects, itemUid);

        // Load object data into edit details page
        loadScenarioEditorObjectForEditing(itemObject, itemType, companyData);

    });

    // Change item input
    $(document).on('change', '.scenario-editor-item-container input, .scenario-editor-item-container select, ' +
        '.scenario-editor-item-container textarea', function () {

        // Get attribute and value
        let itemType = $('.scenario-editor-item-container').data('itemType');
        let attribute = $(this).attr('data-attribute');
        let value = getScenarioEditorItemInputValue($(this), attribute, itemType);

        if (attribute) {

            // Validate input
            let validationCheck = validateScenarioEditorValue(value, attribute, $(this));
            if (!validationCheck.error) {

                // Remove failed validation
                if (attribute !== 'traits') {
                    notie.hideAlerts();
                }
                $(this).removeClass('validation-failed highlight');
                $(this).attr('data-validation-message', null);

                // Get item object
                let itemObject;

                // Get company/scenario details directly
                let companyData = getScenarioEditorSelectedCompanyData(scenarioData);
                if (itemType === 'company-details') {
                    itemObject = companyData['company_details']
                } else if (itemType === 'scenario-details') {
                    companyData = scenarioData;
                    itemObject = scenarioData['scenario_details'];
                }
                // Get item object by type and uid
                else {
                    let itemUid = $('.scenario-editor-item-container').data('uid');
                    let itemObjects = getScenarioEditorItemObjects(companyData, itemType);
                    itemObject = getScenarioEditorItemObject(itemObjects, itemUid);
                }

                // Update object links
                if (attribute === 'name') {
                    updateScenarioEditorObjectLinks(itemObject, value, itemType, companyData, scenarioData)
                }

                // Update object
                updateScenarioEditorObject(itemObject, value, attribute, itemType);

            }
            else {
                // Show failed validation
                $(this).addClass('validation-failed highlight');
                $(this).attr('data-validation-message', validationCheck.message);
                notie.alert({type: 3, text: validationCheck.message, stay: true});
            }
        }

    });

    // Click add item button
    $(document).on('click', '.scenario-editor-add-item-button, .scenario-editor-add-5-items-button', function () {

        let $this = $(this);
        if (!checkScenarioEditorItemValidation()) {
            return false;
        }

        // Process open graphic
        processScenarioEditorItemGraphic();

        // Add company
        if ($('.scenario-editor-main-menu-container').is(":visible")) {

            let itemType = 'companies';
            let companyObjects = scenarioData.companies;
            if (!checkScenarioEditorAddItemLimit(companyObjects.length, itemType)) {
                return false;
            }

            // Create item object
            let newItemObject = createScenarioEditorItemObject(itemType, newScenarioObjectUid.toString());
            newScenarioObjectUid += 1;

            // Add item to companies menu before indies
            let newItemHtml = getScenarioEditorCompaniesMenuItemHtml(newItemObject);
            $('.scenario-editor-companies-menu-container .scenario-editor-menu-button[data-indies="true"]').before(newItemHtml);

            // Scroll to new list item
            $('.scenario-editor-companies-menu-container').scrollTop($('.scenario-editor-companies-menu-container')[0].scrollHeight);

            // Add to companyObjects
            companyObjects.push(newItemObject);

            // Reset scenario companies
            $('.scenario-companies-container').hide();
            $('.search-companies-button.selected').removeClass('selected');
        }

        // Add item (superstar, team etc)
        else {
            let itemType = $('.scenario-editor-menu-button.selected').attr('data-value');
            let companyData = getScenarioEditorSelectedCompanyData(scenarioData);
            let itemObjects = getScenarioEditorItemObjects(companyData, itemType);

            // Get number of items to add
            let numberOfItemsToAdd = 1;
            if ($this.hasClass('scenario-editor-add-5-items-button') && itemType === 'superstars') {
                numberOfItemsToAdd = 5
            }

            // Check max items limit
            if (!checkScenarioEditorAddItemLimit(itemObjects.length + (numberOfItemsToAdd - 1), itemType)) {
                return false;
            }

            let newItemObject;
            for (let i = 0; i < numberOfItemsToAdd; i++) {
                // Create item object
                newItemObject = createScenarioEditorItemObject(itemType, newScenarioObjectUid.toString());
                newScenarioObjectUid += 1;

                // Add item to list
                let newItemHtml = getScenarioEditorListItemHtml(newItemObject, itemType);
                $('.scenario-editor-list-container').append(newItemHtml);

                // Add item to itemObjects
                itemObjects.push(newItemObject);
            }

            // Hide 'no items present' item
            $('.scenario-editor-list-item.none-text').remove();

            // Reset search
            $('.scenario-editor-list-search-input').val('');
            $('.scenario-editor-list-filter.selected').removeClass('selected');
            $('.scenario-editor-list-item').show();
            $('.no-scenario-editor-search-results').hide();

            // Select latest list item, scroll to it
            $('.scenario-editor-list-item.selected').removeClass('selected');
            $('.scenario-editor-list-item').last().addClass('selected');
            $('.scenario-editor-list-container').scrollTop($('.scenario-editor-list-container')[0].scrollHeight);

            // Load object data into edit details page
            loadScenarioEditorObjectForEditing(newItemObject, itemType, companyData);
        }

        notie.alert({type: 4, text: 'Item added'});

    });

    // Click remove item button
    $(document).on('click', '.scenario-editor-remove-item-button', function () {
        notie.confirm({
            text: 'Are you sure?',
            submitCallback: function () {

                // Remove company
                if ($('.scenario-editor-company-menu-container').is(":visible")) {
                    let companyObjects = scenarioData['companies'];

                    // Get company object
                    let companyObject = getScenarioEditorSelectedCompanyData(scenarioData);
                    if (companyObject) {

                        let companyIndex = companyObjects.indexOf(companyObject);
                        if (companyIndex > 0) {
                            // Remove from companyObjects
                            companyObjects.splice(companyIndex, 1);

                            notie.alert({type: 4, text: 'Item removed'});

                            // Show main menu
                            loadScenarioEditorMainPage(scenarioData);
                        }
                        else {
                            notie.alert({type: 3, text: 'The primary company in a scenario cannot be removed'});
                        }
                    }
                    else {
                        notie.alert({type: 3, text: 'Item could not be found'});
                    }
                }

                // Remove item (superstar, team etc)
                else {

                    // Get item object
                    let itemType = $('.scenario-editor-menu-button.selected').attr('data-value');
                    let itemUid = $('.scenario-editor-item-container').data('uid');
                    let companyData = getScenarioEditorSelectedCompanyData(scenarioData);
                    let itemObjects = getScenarioEditorItemObjects(companyData, itemType);
                    let itemObject = getScenarioEditorItemObject(itemObjects, itemUid);

                    if (itemObject) {

                        // Remove from itemObjects
                        itemObjects.splice(itemObjects.indexOf(itemObject), 1);

                        // Remove item from list
                        $('.scenario-editor-list-item[data-uid="' + itemUid + '"]').remove();

                        // Reset search
                        $('.scenario-editor-list-search-input').val('');
                        $('.scenario-editor-list-filter.selected').removeClass('selected');
                        $('.scenario-editor-list-item').show();
                        $('.no-scenario-editor-search-results').hide();

                        // Add empty text if no objects left
                        if (itemObjects.length <= 0) {
                            $('.scenario-editor-list-container').html('<div class="inner-box-item scenario-editor-list-item disabled light-grey none-text">No ' + itemType.replace(/-/g, ' ') + ' present</div>');
                        }

                        notie.alert({type: 4, text: 'Item removed'});

                        // Add empty text to Edit Details page
                        $('.scenario-editor-item-container').html('<div class="font-bold margin-left-5 light-grey margin-top-2">Select an item in the Editor to display its details here</div>');
                        $('.scenario-editor-item-buttons-container').hide();
                    }
                    else {
                        notie.alert({type: 3, text: 'Item could not be found'});
                    }
                }
            }
        });
    });

    // Click move item button
    $(document).on('click', '.scenario-editor-move-item-button', function () {

        if (!checkScenarioEditorItemValidation()) {
            return false;
        }

        // Get companies, excluding current one
        let selectedCompanyUid = $('.scenario-editor-container').data('companyUid');
        let indies = $('.scenario-editor-container').data('indies');
        let moveOptions = '<option selected>Select Company</option>';
        let itemType = $('.scenario-editor-menu-button.selected').attr('data-value');
        scenarioData['companies'].forEach(function(company) {
            if (company['company_details']['uid'] !== selectedCompanyUid) {
                moveOptions += '<option data-uid="' + company['company_details']['uid'] + '">' +
                    company['company_details']['name'] + '</option>';
            }
        });
        // Add indies if company item and not faction/championship
        if (!indies && ['factions', 'championships'].indexOf(itemType) < 0) {
            moveOptions += '<option data-indies="indies">Indies</option>';
        }

        // Add company options, show company select
        $('.scenario-editor-move-item-company-select').html(moveOptions).show();

        // Hide move button
        $(this).hide();
    });

    // Select move company
    $(document).on('change', '.scenario-editor-move-item-company-select', function () {

        // Get company to move to
        let selectedOption = $(this).find(':selected');
        let companyUid = selectedOption.attr('data-uid');
        let indies = !!(selectedOption.attr('data-indies'));
        let companyToMoveToData = getScenarioEditorCompanyData(scenarioData, companyUid, indies);

        if (companyToMoveToData) {

            // Get item object
            let itemType = $('.scenario-editor-menu-button.selected').attr('data-value');
            let itemUid = $('.scenario-editor-item-container').data('uid');
            let companyData = getScenarioEditorSelectedCompanyData(scenarioData);
            let itemObjects = getScenarioEditorItemObjects(companyData, itemType);
            let itemObject = getScenarioEditorItemObject(itemObjects, itemUid);
            let itemObjectsToMoveTo = getScenarioEditorItemObjects(companyToMoveToData, itemType);
            let superstarsToMove;

            // Check item limit
            if (!checkScenarioEditorAddItemLimit(itemObjectsToMoveTo.length, itemType)) {
                return false;
            }

            if (itemObject) {

                // Move superstars for teams/factions
                if (itemType === 'teams' || itemType === 'factions') {
                    let superstarItemObjects = getScenarioEditorItemObjects(companyData, 'superstars');
                    superstarsToMove = Array.from(itemObject['superstars'], function (x) {
                        return superstarItemObjects.filter(function (obj) {
                            return obj['name'] === x;
                        })[0];
                    });
                    let superstarObjectsToMoveTo = getScenarioEditorItemObjects(companyToMoveToData, 'superstars');

                    // Check item limit
                    if (!checkScenarioEditorAddItemLimit(superstarObjectsToMoveTo.length + (superstarsToMove.length - 1), 'superstars')) {
                        return false;
                    }

                    superstarsToMove.forEach(function(superstarToMove) {
                       if (superstarToMove) {
                           moveScenarioEditorItemObject(superstarToMove, superstarItemObjects, 'superstars', superstarObjectsToMoveTo, true);
                       }
                    });
                }

                // Move item object
                moveScenarioEditorItemObject(itemObject, itemObjects, itemType, itemObjectsToMoveTo);

                if (superstarsToMove) {
                    notie.alert({type: 4, text: 'Item and its superstars moved'});
                }
                else {
                    notie.alert({type: 4, text: 'Item moved'});
                }

            }
            else {
                notie.alert({type: 3, text: 'Item could not be found'});
            }
        }
        else {
            notie.alert({type: 3, text: 'Company could not be found'});
        }
    });

    // Randomize item
    $(document).on('click', '.scenario-editor-randomize-item-button', async function () {
        // Get item object
        let itemType = $('.scenario-editor-menu-button.selected').attr('data-value');
        let companyData = getScenarioEditorSelectedCompanyData(scenarioData);
        let itemUid = $('.scenario-editor-item-container').data('uid');
        let itemObjects = getScenarioEditorItemObjects(companyData, itemType);
        let itemObject = getScenarioEditorItemObject(itemObjects, itemUid);

        // Generate superstar
        let data = await generateSuperstar({insert: false, addGraphic: false, generateGimmick: false});

        // Add data to itemObject
        itemObject.pronoun = data.pronoun;
        itemObject.age = data.age;
        itemObject.popularity = data.popularity;
        itemObject.traits = data.traits;
        itemObject.status = 'active';
        itemObject.workrate = getRandomChoice($('.scenario-editor-workrate-select option')).value;
        itemObject.charisma = getRandomChoice($('.scenario-editor-charisma-select option')).value;
        itemObject.overness = getRandomChoice($('.scenario-editor-overness-select option')).value;
        itemObject.alignment = getRandomChoice($('.scenario-editor-alignment-select option')).value;

        // Load inputs, change name and trigger input
        loadScenarioEditorObjectForEditing(itemObject, itemType, companyData);
        $('.scenario-editor-name-input').val(data.name).trigger('change');
    });

    // Set primary company
    $(document).on('click', '.scenario-editor-set-primary-company-button', function () {

        if (!checkScenarioEditorItemValidation()) {
            return false;
        }

        notie.confirm({
            text: 'Are you sure? This company will be moved to the first company\'s position.',
            submitCallback: function () {

                // Get current company
                let companyObjects = scenarioData['companies'];
                let currentCompany = getScenarioEditorSelectedCompanyData(scenarioData);
                let originalPrimaryCompany = companyObjects[0];

                // Check if company is already primary company
                if (originalPrimaryCompany === currentCompany) {
                    notie.alert({type: 3, text: 'This company is already the primary company'});
                    return false;
                }

                if (currentCompany) {

                    // Move company to first position
                    companyObjects.splice(companyObjects.indexOf(currentCompany), 1);
                    companyObjects.unshift(currentCompany);

                    // Get original starting event and its index
                    let originalStartingEvent = originalPrimaryCompany.events.filter(function (obj) {
                        return obj['name'] === scenarioData.scenario_details.starting_event;
                    })[0];
                    let startingEventIndex = originalPrimaryCompany.events.indexOf(originalStartingEvent);

                    // Use index to set new starting event
                    scenarioData.scenario_details.starting_event = currentCompany.events[startingEventIndex].name;

                    notie.alert({type: 4, text: 'Primary company changed'});

                    // Show main menu
                    loadScenarioEditorMainPage(scenarioData);

                }
                else {
                    notie.alert({type: 3, text: 'Item could not be found'});
                }
            }
        });
    });

    // List search
    $(document).on('input', '.scenario-editor-list-search-input', function () {
        runScenarioEditorListSearch();
    });

    // List filter
    $(document).on('click', '.scenario-editor-list-filter', function () {
        let filterName;

        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
        }
        else {
            $('.scenario-editor-list-filter.selected').removeClass('selected');
            $(this).addClass('selected');
            filterName = $(this).attr('data-value');
        }

        applyScenarioEditorListFilter(filterName);
    });

    // Click publish button
    $('.scenario-editor-publish-button').on('click', function () {
        if (globals.requestRunning) {
            return false;
        }
        if (!checkScenarioEditorItemValidation()) {
            return false;
        }
        if (!checkScenarioValidation(scenarioData)) {
            return false;
        }
        notie.confirm({
            text: "Are you sure? Please check the 'Changes Made' section to go over your changes.",
            submitCallback: async function () {
                await addScenarioDataRequest(scenarioData);
            }
        });
    });

    /* Scenario Companies */

    // Search companies menu button
    $(document).on('click', ".search-companies-button", function () {
        if ($(this).hasClass('selected')) {
            $(this).removeClass('selected');
            $('.scenario-companies-container').hide();
        }
        else {
            $(this).addClass('selected');
            $('.scenario-companies-container').show();
            $('.scenario-companies-results').hide();
            $('.scenario-companies-search-input').val('').focus();
            if (!globalUser.paid) {
                $('.scenario-companies-container').find('.scenario-companies-info').show()
            }
        }
    });

    // Search scenario companies
    $(document).on('click', '.scenario-companies-search-button', function () {
        let searchTerm = $(this).siblings('.scenario-companies-search-input').val();
        // Validate
        if (searchTerm.length <= 0) {
            notie.alert({type: 3, text: "Enter a company name to search for"});
            // Put focus back on search field
            $(this).siblings('.scenario-companies-search-input').focus();
            return false;
        }
        runScenarioCompaniesSearch(searchTerm);
    });

    // 'Enter' keypress to search
    $(document).on('keypress', '.scenario-companies-search-input', function(e){
        // Trigger search on enter key press
        if (e.which === 13) {
            e.preventDefault();
            $(e.target).siblings(".scenario-companies-search-button").trigger('click');
        }
    });

    // Next/previous page buttons
    $(document).on('click', '.scenario-companies-next-page-button, .scenario-companies-previous-page-button', function () {
        let page = $(this).data('page');
        let parent = $(this).closest('.scenario-companies-container');
        let searchTerm = parent.find('.scenario-companies-search-input').val();
        runScenarioCompaniesSearch(searchTerm, page);
    });

    // Load scenario company
    $(document).on('click', '.scenario-editor-container .scenario-companies-search-result-item', function () {
        if (globals.requestRunning) {
            return false;
        }
        if ($(this).hasClass('disabled')) {
            return false;
        }
        if (!checkScenarioEditorItemValidation()) {
            return false;
        }
        if (!checkScenarioEditorAddItemLimit(scenarioData.companies.length, 'companies')) {
            return false;
        }

        let uid = $(this).attr('data-uid');

        makeGetRequest('/_get_community_company_data', {uid: uid},
			(data) => {
				if (!data['error']) {
					let newItemObject = data;

                    // Add item to companies menu before indies
                    let newItemHtml = getScenarioEditorCompaniesMenuItemHtml(newItemObject);
                    $('.scenario-editor-companies-menu-container .scenario-editor-menu-button[data-indies="true"]')
                        .before(newItemHtml);

                    // Scroll to new list item
                    $('.scenario-editor-companies-menu-container').scrollTop(
                        $('.scenario-editor-companies-menu-container')[0].scrollHeight);

                    // Add to companyObjects
                    scenarioData.companies.push(newItemObject);

                    // Reset scenario companies
                    $('.scenario-companies-container').hide();
                    $('.search-companies-button.selected').removeClass('selected');

                    notie.alert({type: 4, text: 'Company added'});
				} else {
                    if (data['error'] === 'not-found') {
                        notie.alert({type: 3, text: 'That company could not be found. Please try again.', stay: true});
                    }
                    if (data['error'] === 'not-paid') {
                        notie.alert({type: 3, text: 'You need to have JoW Paid to add a Community Company to your Scenario.', stay: true});
                    }
				}
			});
    });

    /* Editor Item UI (right column) */

    // Show/hide injured/gimmick/manager/training inputs
    $(document).on('change', '.scenario-editor-injured-input, .scenario-editor-gimmick-input, .scenario-editor-manager-input, ' +
        '.scenario-editor-training-input, .scenario-editor-future-input', function () {
        toggleScenarioEditorItemInputsContainer($(this));
        // Focus shown input
        if ($(this).hasClass('scenario-editor-gimmick-input')) {
            $('.scenario-editor-gimmick-name-input').focus()
        }
        if ($(this).hasClass('scenario-editor-injured-input')) {
            $('.scenario-editor-injured-months-input').focus()
        }
        if ($(this).hasClass('scenario-editor-future-input')) {
            $('.scenario-editor-year-input').focus()
        }
    });

    // Show/hide gimmick match consequence inputs
    $(document).on('change', '.scenario-editor-consequence-select', function () {
        toggleScenarioEditorConsequenceInput($(this));
        // Focus shown input
        $('.scenario-editor-contract-name-input').focus();
    });

    // Show/hide third superstar for team
    $(document).on('change', '.scenario-editor-team-type-select', function () {
        toggleScenarioEditorTeamTypeInput($(this));
        // Trigger change to update members
        $('.scenario-editor-third-superstar-select').trigger('change');
    });

    // Update faction leader select
    $(document).on('change', '.scenario-editor-faction-member-select', function () {
        updateScenarioEditorFactionLeaderSelect();
    });

    // Add managed talent select
    $(document).on('click', '.scenario-editor-add-managed-talent-button', function () {
        // Get existing talent inputs
        let parentBox = $(this).closest('.superstar-manager-container');
        let managedTalentInputs = parentBox.find('.scenario-editor-managed-talent-select');

        // Check for maximum talent inputs
        if (managedTalentInputs.length >= 15) {
            notie.alert({type: 3, text: 'You cannot select more than 15 talent to manage'});
            return false;
        }

        // Clone talent select, add remove button
        let managedTalentInputHtml = '<div class="margin-bottom-8">' +
            managedTalentInputs.eq(0).clone().addClass('compact').prop('outerHTML') +
            '<button type="button" class="scenario-editor-remove-managed-talent-button button retro-button styled-select-button margin-left-6">' +
            '<i class="fa fa-minus"></i>' +
            '</button></div>';

        // Add talent select after last one
        managedTalentInputs.last().parent().after(managedTalentInputHtml);
    });

    // Remove managed talent select
    $(document).on('click', '.scenario-editor-remove-managed-talent-button', function () {
        let previousManagedTalentSelect = $(this).parent().prev().find('.scenario-editor-managed-talent-select');
        $(this).parent().remove();
        // Update attribute
        previousManagedTalentSelect.trigger('change');
    });

    // Add faction member select
    $(document).on('click', '.scenario-editor-add-faction-member-button', function () {
        // Get existing faction member selects
        let parentBox = $(this).closest('.scenario-editor-item-container');
        let factionMemberSelects = parentBox.find('.scenario-editor-faction-member-select');

        // Check for maximum faction member selects
        if (factionMemberSelects.length >= gameLimits.maxFactionSuperstars) {
            notie.alert({type: 3, text: 'You cannot select more than ' + gameLimits.maxFactionSuperstars + ' faction members'});
            return false;
        }

        // Clone faction member select, add remove button
        let factionMemberSelectHtml = '<div class="margin-bottom-8">' +
            factionMemberSelects.eq(0).clone().addClass('compact').prop('outerHTML') +
            '<button type="button" class="scenario-editor-remove-faction-member-button button retro-button styled-select-button margin-left-6">' +
            '<i class="fa fa-minus"></i>' +
            '</button></div>';

        // Add faction member select after last one
        factionMemberSelects.last().parent().after(factionMemberSelectHtml);
    });

    // Remove faction member select
    $(document).on('click', '.scenario-editor-remove-faction-member-button', function () {
        let previousFactionMemberSelect = $(this).parent().prev().find('.scenario-editor-faction-member-select');
        $(this).parent().remove();
        // Update attribute
        previousFactionMemberSelect.trigger('change');
    });

    // Change championship division
    $(document).on('change', '.scenario-editor-division-select', function () {
        // Get champion options based on championship division
        let championOptions;
        let division = $(this).val();
        let companyData = getScenarioEditorSelectedCompanyData(scenarioData);

        if (division === 'tag-team') {
            championOptions = getScenarioEditorInputOptions('teams', companyData)
        }
        else if (division === 'trio') {
            championOptions = getScenarioEditorInputOptions('trios', companyData)
        }
        else {
            championOptions = getScenarioEditorInputOptions('main-roster-current-superstars', companyData)
        }

        // Add new champion options, trigger change to set champion's value
        $('.scenario-editor-champion-select').html(championOptions).trigger('change');
    });

    // Change color preview upon move
    $(document).on('move.spectrum', '.scenario-editor-color-input', function (e, tinycolor) {
        let brandColor = (tinycolor) ? tinycolor.toHexString() : '';
        $(this).val(brandColor);
        $(this).parent().parent().find('.scenario-editor-color-preview').css('color', brandColor)
    });

    // Trigger color input change upon dragstop so that attribute updates
    $(document).on('dragstop.spectrum', '.scenario-editor-color-input', function () {
        $(this).trigger('change');
    });

    // Select trait item
    $(document).on('click', '.scenario-editor-item-container .superstar-trait-item-container', function () {
        // Update attribute
        $(this).closest('.scenario-editor-item-container').find('.superstar-traits-selection-input').trigger('change');
    });

    // Add superstar graphic
    $(document).on('click', '.add-scenario-editor-superstar-graphic', function () {
        $(this).hide();
        let parent = $(this).parent();

        // Set character data
        let jsonData = parent.data('graphicCode');
        let characterData;
        if (jsonData) {
            characterData = [jsonData]
        }

        // Show remove graphic button
        $(this).siblings('.remove-scenario-editor-graphic-button').show();

        // Show graphic
        let graphicContainer = $(this).siblings('.character-creator');
        let el = graphicContainer.find('.superstar-graphic');
        showScenarioEditorSuperstarGraphic(characterData, el);
        graphicContainer.show();
        $(el).show();
    });

    // Remove superstar graphic
    $(document).on('click', '.remove-scenario-editor-graphic-button', function () {
        $(this).hide();
        let parent = $(this).parent();

        // Remove character data
        parent.data('graphicCode', null);

        // Remove character creator
        let graphicContainer = $(this).siblings('.character-creator');
        graphicContainer.hide();
        graphicContainer.find('.superstar-graphic').html('');

        // Reset add graphic button
        $(this).siblings('.add-graphic-button').text('Add Graphic').show();

        // Set graphic attribute to null
        $('.scenario-editor-graphic-input').val(null).trigger('change');
    });

    // Add championship graphic
    $(document).on('click', '.add-scenario-editor-championship-graphic', function () {
        $(this).hide();
        let parent = $(this).parent();

        // Set character data
        let jsonData = parent.data('graphicCode');
        let graphicData;
        if (jsonData) {
            graphicData = [jsonData]
        }

        // Show remove character button
        $(this).siblings('.remove-scenario-editor-graphic-button').show();

        // Show graphic
        let graphicContainer = $(this).siblings('.character-creator');
        let el = graphicContainer.find('.superstar-graphic');
        showScenarioEditorChampionshipGraphic(graphicData, el);
        graphicContainer.show();
        $(el).show();
    });
});

async function createScenarioMenuButtonHandler() {
    if (!globalUser.loggedIn) {
        playSoundEffect('error');
        notie.alert({type: 4, text: "You need to login to create a scenario", stay: true});
        return false;
    }

    playSoundEffect('success');
    hideMainMenuContent($());

    // Create new scenario object and copy original
    scenarioData = createScenarioEditorItemObject('scenarios', newScenarioObjectUid.toString());
    newScenarioObjectUid += 1;
    originalScenarioData = JSON.parse(JSON.stringify(scenarioData));

    // Load main page
    loadScenarioEditorMainPage(scenarioData);

    if (scenarioEditorInfoShown) {
        $('.scenario-editor-container').fadeIn('slow');
    }
    else {
        $('.scenario-editor-info-container').hide().fadeIn();
        scenarioEditorInfoShown = true;
    }
}

function createScenarioEditorItemObject(itemType, uid) {
    let newItemObject;
    switch (itemType) {
        case 'superstars':
            newItemObject = {"name": "Superstar", "age": 25, "popularity": 600, "status": "active", "hall_of_famer": false,
                "injured": 0, "pronoun": "he", "alignment": null, "workrate": 2, "charisma": 2, "gimmick": null, "full_time_manager": null,
                "brand_name": null, "managed_talent_names": [], "month_to_appear_in": null, "overness": "Average", "training": false,
                "traits": [], "graphic": null, "uid": uid}
            break;
        case 'teams':
            newItemObject = {"name": "Team", "superstars": [], "team_type": "tag-team", "uid": uid}
            break;
        case 'factions':
            newItemObject = {"leader_superstar": null, "name": "Faction", "reputation": 5, "superstars": [], "type": "faction",
                "uid": uid}
            break;
        case 'championships':
            newItemObject = {"brand_name": null, "champion": null, "division": "singles", "graphic": null,
                "name": "Championship", "prestige": "B", "rank": "Upper Midcarder", "uid": uid}
            break;
        case 'gimmick-matches':
            newItemObject = {"consequence": null, "injury_rate": 1, "name": "Gimmick Match", "rating_boost": 2,
                "rules": null, "description": null, "contract_name": null, "graphic_type": null, "add_random_weapons": false,
                "uid": uid}
            break;
        case 'brands':
            newItemObject = {"color": null, "name": "Brand", "overness": "Average", "uid": uid, "weekly_show_is_exclusive": true,
                "weekly_show_name": null}
            break;
        case 'match-contracts':
            newItemObject = {"event": "", "name": "Title Match", "talent": "", "uid": uid}
            break;
        case 'streaks':
            newItemObject = {"event": "", "length": 5, "name": "Streak", "talent": "", "uid": uid}
            break;
        case 'events':
            newItemObject = {"brand_name": null, "name": "Event", "prestige": "B", "uid": uid, "weekly_show_after_name": null,
                "weekly_show_before_name": null}
            break;
        case 'companies':
            // Create 12 monthly events for company
            let events = [];
            let eventUid = 1;
            for (let step = 0; step < 12; step++) {
                let newEvent = createScenarioEditorItemObject('events', eventUid.toString());
                newEvent.name = monthNames[step];
                events.push(newEvent);
              eventUid++;
            }
            // Create default gimmick matches
            let gimmickMatches = getScenarioEditorDefaultGimmickMatches();
            // Create company object
            newItemObject = {"brands": [], "championships": [],
                "company_details": {"creative_points": 500, "name": "Company", "overness": "Average", "owner_name": null, "reputation": 5,
                  "style": "entertainment", "top_event": events[0].name, "uid": uid, "weekly_show_name": null}, "events": events,
                "factions": [], "superstars": [], "teams": [], "streaks": [], "gimmick_matches": gimmickMatches, "match_contracts": []}
            break;
        case 'scenarios':
            let defaultCompany = createScenarioEditorItemObject('companies', uid.toString());
            newItemObject = {"scenario_details": {"allow_edits": true, "allow_sharing": true, "comments": "", "description": "",
                "market_size": 4000000, "name": "My Scenario", "private": false, "starting_event": defaultCompany.events[0].name,
                "starting_year": new Date().getFullYear(), "scenario_type": "scenario"},
                "companies": [defaultCompany], "indies": {"superstars": [], "teams": [], "brands": []}}
            break;
    }
    return newItemObject;
}

function getScenarioEditorDefaultGimmickMatches() {
    return [
        {
            "consequence": null,
            "contract_name": null,
            "description": "Superstars battle it out anywhere in the arena using weapons.",
            "injury_rate": 1,
            "name": "Street Fight",
            "rating_boost": 1,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": true,
            "uid": "-1"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The only way to win is to put your opponent through a table.",
            "injury_rate": 2,
            "name": "Tables",
            "rating_boost": 1,
            "rules": null,
            "graphic_type": "table",
            "add_random_weapons": false,
            "uid": "-2"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "Superstars brawl it out in a special location.",
            "injury_rate": 2,
            "name": "Brawl",
            "rating_boost": 1,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": true,
            "uid": "-3"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The only way to win is to climb the ladder and grab the prize. This match can only be held for a championship.",
            "injury_rate": 3,
            "name": "Ladder",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": "ladder",
            "add_random_weapons": false,
            "uid": "-4"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "Teams battle it out in an elimination tag match, where an entire team must be eliminated for the match to end.",
            "injury_rate": 1,
            "name": "Elimination",
            "rating_boost": 2,
            "rules": "elimination",
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-5"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The first superstar to score a submission and make their opponent tap wins the match.",
            "injury_rate": 1,
            "name": "Submission",
            "rating_boost": 1,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-6"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "A marathon match to see who is the best.",
            "injury_rate": 1,
            "name": "Ironman",
            "rating_boost": 3,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-7"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "Superstars are locked inside a steel cage, with only one survivor.",
            "injury_rate": 3,
            "name": "Steel Cage",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": "cage_grey",
            "add_random_weapons": false,
            "uid": "-8"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "Superstars are eliminated if thrown over the top rope and both feet touch the floor. Last remaining superstar wins!",
            "injury_rate": 1,
            "name": "Battle Royal",
            "rating_boost": 2,
            "rules": "battle_royal",
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-9"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "Tables Ladders and Chairs, oh my! This match can only be held for a championship.",
            "injury_rate": 3,
            "name": "TLC",
            "rating_boost": 3,
            "rules": null,
            "graphic_type": "tables_ladders_chairs",
            "add_random_weapons": false,
            "uid": "-10"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The only way to win is to humiliate your opponent and make them quit.",
            "injury_rate": 2,
            "name": "I Quit",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-11"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "A fight without any rules or consequences where anything goes.",
            "injury_rate": 2,
            "name": "Unsanctioned",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": true,
            "uid": "-12"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The only way to win is to force your opponent into the back of an ambulance.",
            "injury_rate": 2,
            "name": "Ambulance",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": "ambulance",
            "add_random_weapons": false,
            "uid": "-25"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The only way to win is to knock your opponent out for a ten count.",
            "injury_rate": 2,
            "name": "LMS",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": true,
            "uid": "-13"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The only way to win is to put your opponent in a casket and close it!",
            "injury_rate": 1,
            "name": "Casket",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": "casket",
            "add_random_weapons": false,
            "uid": "-14"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "Superstars are locked in a large, high steel cell, where they battle to survive.",
            "injury_rate": 3,
            "name": "Steel Cell",
            "rating_boost": 3,
            "rules": null,
            "graphic_type": "cage_grey",
            "add_random_weapons": false,
            "uid": "-15"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The first superstar to score two falls wins.",
            "injury_rate": 3,
            "name": "2/3 Falls",
            "rating_boost": 3,
            "rules": "2/3_falls",
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-16"
        },
        {
            "consequence": "loser_unavailable",
            "contract_name": null,
            "description": "A grudge match in which the loser is forced to take takes a hiatus from the company.",
            "injury_rate": 1,
            "name": "Loser Leaves",
            "rating_boost": 3,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-17"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "The first superstar to make their opponent bleed wins the match.",
            "injury_rate": 1,
            "name": "First Blood",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-18"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "A guest referee is selected to enforce the match.",
            "injury_rate": 1,
            "name": "Special Referee",
            "rating_boost": 2,
            "rules": "special_referee",
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-19"
        },
        {
            "consequence": "random_opponent",
            "contract_name": null,
            "description": "A random superstar shows up to answer the open challenge!",
            "injury_rate": 1,
            "name": "Open Challenge",
            "rating_boost": 1,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-20"
        },
        {
            "consequence": "remove_hair",
            "contract_name": null,
            "description": "The losing superstar gets their hair shaved off!",
            "injury_rate": 1,
            "name": "Hair vs Hair",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-21"
        },
        {
            "consequence": "remove_mask",
            "contract_name": null,
            "description": "The losing superstar is forced to unmask!",
            "injury_rate": 1,
            "name": "Mask vs Mask",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-22"
        },
        {
            "consequence": "remove_mask_or_hair",
            "contract_name": null,
            "description": "One superstar will be forced to either remove their mask or shave their hair!",
            "injury_rate": 1,
            "name": "Mask vs Hair",
            "rating_boost": 2,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-23"
        },
        {
            "consequence": null,
            "contract_name": null,
            "description": "An object hangs off a pole, the goal being to claim it or use it. Can be a hit or a big miss!",
            "injury_rate": 1,
            "name": "Pole",
            "rating_boost": 1,
            "rules": null,
            "graphic_type": null,
            "add_random_weapons": false,
            "uid": "-24"
        }
    ]
}

function loadScenarioEditorMainPage(scenarioData) {
    let parent = $('.scenario-editor-container');

    // Unselect menu buttons
    $('.scenario-editor-menu-button.selected').removeClass('selected');

    // Add headers
    let scenarioNameHtml = getScenarioNameHtml(scenarioData);
    if (parent.find('.scenario-editor-first-header').html() !== scenarioNameHtml) {
        parent.find('.scenario-editor-first-header').html(scenarioNameHtml).hide().fadeIn();
    }
    parent.find('.scenario-editor-second-header').text('');

    // Show/hide menu buttons
    parent.find('.scenario-editor-main-menu-container').fadeIn();
    parent.find('.scenario-editor-companies-menu-container').hide();
    parent.find('.scenario-editor-company-menu-container, .scenario-editor-indies-menu-container').hide();

    // Get and show companies menu buttons
    let companiesMenuHtml = getScenarioEditorCompaniesMenuHtml(scenarioData);
    parent.find('.scenario-editor-companies-menu-container').html(companiesMenuHtml).fadeIn();
    parent.find('.scenario-editor-companies-menu-container').scrollTop(0);
    parent.find('.scenario-editor-companies-header').fadeIn();

    // Hide list container, show list buttons
    parent.find('.scenario-editor-list-container, .scenario-editor-list-menu-container').hide();
    parent.find('.scenario-editor-add-5-items-button').hide();
    parent.find('.scenario-editor-list-buttons-container').hide().fadeIn();
    parent.find('.search-companies-button').show();

    // Show/hide bottom buttons
    parent.find('.scenario-editor-publish-button').show();
    parent.find('.scenario-editor-back-button, .scenario-editor-main-menu-button').hide();

    // Reset scenario companies
    $('.scenario-companies-container').hide();
    $('.search-companies-button.selected').removeClass('selected');

    // Add empty text to Edit Details page
    parent.find('.scenario-editor-item-container').html('<div class="font-bold margin-left-5 light-grey margin-top-2">' +
        'Select an item in the Editor to display its details here</div>');
    parent.find('.scenario-editor-item-buttons-container').hide();

    // Select scenario details button
    $('.scenario-editor-menu-button[data-value="scenario-details"]').trigger('click');
}

function getScenarioNameHtml(data) {
    if (data['scenario_details']['scenario_type'] === 'scenario') {
        let versionText = (data['scenario_details']['version']) ? '(Version {0})'.format(
            data['scenario_details']['version']) : '';
        return '{0} <span class="grey margin-left-2">Scenario {1}</span>'.format(
            escapeHTML(data['scenario_details']['name']), versionText);
    }
    else if (data['scenario_details']['scenario_type'] === 'scenario_edit') {
        let versionText = (data['scenario_details']['edit_version']) ? '(Version {0})'.format(
            data['scenario_details']['edit_version']) : '';
        return '{0} <span class="grey margin-left-2">Scenario Edit {1}</span>'.format(
            escapeHTML(data['scenario_details']['name']), versionText);
    }
}

function getScenarioEditorCompaniesMenuHtml(scenarioData) {
    let companiesMenuHtml = '';

    // Add companies
    scenarioData['companies'].forEach(function(companyData) {
        companiesMenuHtml += getScenarioEditorCompaniesMenuItemHtml(companyData)
    });

    // Add indies
    companiesMenuHtml += '<div class="scenario-editor-menu-button margin-bottom-2" data-indies="true">Indies</div>';

    return companiesMenuHtml;
}

function getScenarioEditorCompaniesMenuItemHtml(companyData) {
    return '<div class="scenario-editor-menu-button margin-bottom-10" ' +
        'data-uid="' + companyData['company_details']['uid'] + '">' + escapeHTML(companyData['company_details']['name']) + '</div>';
}

function checkScenarioEditorItemValidation() {
    let validationFailedInput = $('.scenario-editor-item-container').find('.validation-failed');

    if (validationFailedInput.length > 0) {

        // Show notie if not present
        if ($('.notie-container').length <= 0) {
            let validationFailedMessage = validationFailedInput.attr('data-validation-message');
            notie.alert({type: 3, text: validationFailedMessage, stay: true});
        }

        return false
    }
    return true;
}

function loadScenarioEditorObjectForEditing(object, itemType, companyData) {
    let scenarioEditorItemContainer = $('.scenario-editor-item-container');

    // Add data to editor
    scenarioEditorItemContainer.data('uid', object.uid);
    scenarioEditorItemContainer.data('itemType', itemType);

    // Add object inputs
    let scenarioEditorObjectInputsHtml = getScenarioEditorObjectInputsHtml(object, itemType, companyData);
    scenarioEditorItemContainer.html(scenarioEditorObjectInputsHtml);

    // Add input values
    addScenarioEditorObjectInputValues(object, itemType);

    // Show item buttons except for scenario details and events
    if (['scenario-details', 'events'].indexOf(itemType) < 0) {
        $('.scenario-editor-item-buttons-container').show();
        $('.scenario-editor-move-item-company-select').hide();

        // Show randomize button
        if (itemType === 'superstars') {
            $('.scenario-editor-item-buttons-container').find('.scenario-editor-randomize-item-button').show();
        }
        else {
            $('.scenario-editor-item-buttons-container').find('.scenario-editor-randomize-item-button').hide();
        }

        // Show move button
        if (['superstars', 'teams', 'factions', 'championships'].indexOf(itemType) >= 0) {
            $('.scenario-editor-item-buttons-container').find('.scenario-editor-move-item-button').show();
        }
        else {
            $('.scenario-editor-item-buttons-container').find('.scenario-editor-move-item-button').hide();
        }

        // Show 'set primary' button
        if (itemType === 'company-details') {
            $('.scenario-editor-item-buttons-container').find('.scenario-editor-set-primary-company-button').show();
        }
        else {
            $('.scenario-editor-item-buttons-container').find('.scenario-editor-set-primary-company-button').hide();
        }
    }
    else {
        $('.scenario-editor-item-buttons-container').hide();
    }
}

function addScenarioEditorObjectInputValues(object, itemType) {
    let scenarioEditorItemContainer = $('.scenario-editor-item-container');

    // Add input values based on itemType
    $('.scenario-editor-name-input').val(object.name.trim());

    if (itemType === 'superstars') {
        $('.scenario-editor-age-input').val(object.age);
        $('.scenario-editor-popularity-input').val(object.popularity);
        $('.scenario-editor-pronoun-select').val(object.pronoun);
        $('.scenario-editor-charisma-select').val(object.charisma);
        $('.scenario-editor-workrate-select').val(object.workrate);
        $('.scenario-editor-alignment-select').val(object.alignment);
        $('.scenario-editor-overness-select').val(object.overness);
        $('.scenario-editor-status-select').val(object.status);
        $('.scenario-editor-full-time-manager-input').prop('checked', object.full_time_manager);
        $('.scenario-editor-hall-of-famer-input').prop('checked', object.hall_of_famer);

        // Add graphic
        let graphicCode = object.graphic;
        scenarioEditorItemContainer.data('graphicCode', graphicCode);
        if (graphicCode) {
            scenarioEditorItemContainer.find('.add-graphic-button').text('Edit Graphic');
            scenarioEditorItemContainer.find('.remove-scenario-editor-graphic-button').show();
        }

        // Add brand
        if (object.brand_name) {
            $('.scenario-editor-brand-select').val(object.brand_name.trim());
        }
        else {
            $('.scenario-editor-brand-select').val('None');
        }

        // Add gimmick
        if (object.gimmick && object.gimmick.name) {
            $('.scenario-editor-gimmick-name-input').val(object.gimmick.name);
            $('.scenario-editor-gimmick-effectiveness-select').val(object.gimmick.effectiveness);
            $('.scenario-editor-gimmick-input').prop('checked', true);
            toggleScenarioEditorItemInputsContainer($('.scenario-editor-gimmick-input'));
        }

        // Add injury months
        if (object.injured > 0) {
            $('.scenario-editor-injured-months-input').val(object.injured);
            $('.scenario-editor-injured-input').prop('checked', true);
            toggleScenarioEditorItemInputsContainer($('.scenario-editor-injured-input'));
        }

        // Add managed talent names
        if (object.managed_talent_names.length > 0) {
            object.managed_talent_names.forEach(function(objectManagedTalent, i) {
                if (i > 0) {
                    scenarioEditorItemContainer.find('.scenario-editor-add-managed-talent-button').trigger('click')
                }
                $('.scenario-editor-managed-talent-select').eq(i).val(objectManagedTalent.trim())
            });
            $('.scenario-editor-manager-input').prop('checked', true);
            toggleScenarioEditorItemInputsContainer($('.scenario-editor-manager-input'));
        }

        // Add training and months to appear in
        if (object.training) {
            $('.scenario-editor-training-input').prop('checked', true);
            toggleScenarioEditorItemInputsContainer($('.scenario-editor-training-input'));
        }
        if (object.month_to_appear_in) {
            let futureSuperstarYear = Math.floor(object.month_to_appear_in / 12);
            let futureSuperstarMonth = object.month_to_appear_in % 12;
            $('.scenario-editor-year-input').val(futureSuperstarYear);
            $('.scenario-editor-month-input').val(futureSuperstarMonth);
            $('.scenario-editor-future-input').prop('checked', true);
            toggleScenarioEditorItemInputsContainer($('.scenario-editor-future-input'));
        }

        // Add traits
        let traitElements = scenarioEditorItemContainer.find('.superstar-trait-item-container').filter(function (i, e) {
            return object.traits.indexOf($(e).text().trim().replace(/\s+/g, " ")) >= 0
        });
        traitElements.each(function(i, traitElement) {
           selectSuperstarTraitElement($(traitElement))
        });
    }
    else if (itemType === 'teams') {
        $('.scenario-editor-team-type-select').val(object.team_type);
        toggleScenarioEditorTeamTypeInput($('.scenario-editor-team-type-select'));
        object.superstars.forEach(function(objectSuperstar, i) {
            if (i === 0) {
                $('.scenario-editor-first-superstar-select').val(objectSuperstar.trim())
            }
            else if (i === 1) {
                $('.scenario-editor-second-superstar-select').val(objectSuperstar.trim())
            }
            else if (i === 2) {
                $('.scenario-editor-third-superstar-select').val(objectSuperstar.trim())
            }
        })
    }
    else if (itemType === 'factions') {
        $('.scenario-editor-reputation-input').val(object.reputation);
        object.superstars.forEach(function(factionMember, i) {
            if (i > 1) {
                scenarioEditorItemContainer.find('.scenario-editor-add-faction-member-button').trigger('click')
            }
            $('.scenario-editor-faction-member-select').eq(i).val(factionMember.trim())
        });
        updateScenarioEditorFactionLeaderSelect();
        if (object.leader_superstar) {
            $('.scenario-editor-faction-leader-select').val(object.leader_superstar.trim());
        }
        else {
            $('.scenario-editor-faction-leader-select').val('None');
        }
    }
    else if (itemType === 'championships') {
        if (object.champion) {
            $('.scenario-editor-champion-select').val(object.champion.trim());
        }
        else {
            $('.scenario-editor-champion-select').val('None');
        }
        $('.scenario-editor-division-select').val(object.division);
        $('.scenario-editor-prestige-select').val(object.prestige);
        $('.scenario-editor-rank-select').val(object.rank);

        // Add graphic
        let graphicCode = object.graphic;
        scenarioEditorItemContainer.data('graphicCode', graphicCode);
        if (graphicCode) {
            scenarioEditorItemContainer.find('.add-graphic-button').text('Edit Graphic');
            scenarioEditorItemContainer.find('.remove-scenario-editor-graphic-button').show();
        }

        if (object.brand_name) {
            $('.scenario-editor-brand-select').val(object.brand_name.trim());
        }
        else {
            $('.scenario-editor-brand-select').val('None');
        }
    }
    else if (itemType === 'events') {
        $('.scenario-editor-prestige-select').val(object.prestige);
        $('.scenario-editor-weekly-show-before-event-input').val(object.weekly_show_before_name);
        $('.scenario-editor-weekly-show-after-event-input').val(object.weekly_show_after_name);
        if (object.brand_name) {
            $('.scenario-editor-brand-select').val(object.brand_name.trim());
        }
        else {
            $('.scenario-editor-brand-select').val('None');
        }
    }
    else if (itemType === 'gimmick-matches') {
        $('.scenario-editor-rules-select').val(object.rules);
        $('.scenario-editor-rating-select').val(object.rating_boost);
        $('.scenario-editor-injury-rate-select').val(object.injury_rate);
        $('.scenario-editor-consequence-select').val(object.consequence);
        toggleScenarioEditorConsequenceInput($('.scenario-editor-consequence-select'));
        $('.scenario-editor-contract-name-input').val(object.contract_name);
        $('.scenario-editor-description-input').val(object.description);
        $('.scenario-editor-graphic-type-select').val(object.graphic_type);
        $('.scenario-editor-add-random-weapons-input').prop('checked', object.add_random_weapons);
    }
    else if (itemType === 'brands') {
        $('.scenario-editor-weekly-show-name-input').val(object.weekly_show_name);
        $('.scenario-editor-overness-select').val(object.overness);
        $('.scenario-editor-exclusive-weekly-show-input').prop('checked', object.weekly_show_is_exclusive);

        // Set color input
        $(".scenario-editor-color-input").spectrum({
            preferredFormat: "hex",
            allowEmpty: true,
            showInitial: true,
            showInput: true,
            showButtons: false
        });

        // Set color, preview
        if (object.color) {
            $('.scenario-editor-color-preview').css('color', object.color);
            $('.scenario-editor-color-input').val(object.color);
            $('.scenario-editor-color-input').spectrum('set', object.color);
        }
    }
    else if (itemType === 'streaks') {
        $('.scenario-editor-event-select').val(object.event.trim());
        $('.scenario-editor-talent-select').val(object.talent.trim());
        $('.scenario-editor-length-input').val(object.length);
    }
    else if (itemType === 'match-contracts') {
        $('.scenario-editor-event-select').val(object.event.trim());
        $('.scenario-editor-talent-select').val(object.talent.trim());
    }
    else if (itemType === 'company-details') {
        $('.scenario-editor-reputation-input').val(object.reputation);
        $('.scenario-editor-style-select').val(object.style);
        $('.scenario-editor-creative-points-input').val(object.creative_points);
        $('.scenario-editor-owner-name-input').val(object.owner_name);
        $('.scenario-editor-weekly-show-name-input').val(object.weekly_show_name);
        $('.scenario-editor-top-event-select').val(object.top_event.trim());
        $('.scenario-editor-overness-select').val(object.overness);
    }
    else if (itemType === 'scenario-details') {
        $('.scenario-editor-description-input').val(object.description);
        if (object.market_size) {
            $('.scenario-editor-market-size-select').val(object.market_size);
        }
        $('.scenario-editor-comments-input').val(object.comments);
        $('.scenario-editor-starting-year-input').val(object.starting_year);
        $('.scenario-editor-starting-event-select').val(object.starting_event.trim());
        $('.scenario-editor-private-input').prop('checked', object.private);
        $('.scenario-editor-allow-edits-input').prop('checked', object.allow_edits);
        $('.scenario-editor-allow-sharing-input').prop('checked', object.allow_sharing);
    }
}

function getScenarioEditorObjectInputsHtml(object, itemType, companyData) {
    let inputsHtml;
    if (itemType === 'superstars') {

        // Training checkbox
        let trainingInput = '';
        let trainingContainerClass = ' display-none';
        let indies = $('.scenario-editor-container').data('indies');
        if (!indies) {
            trainingInput =
            '        <label class="control control--checkbox">' +
            '            Training' +
            '            <input type="checkbox" class="scenario-editor-training-input" tabindex="15" data-attribute="training"/>' +
            '            <div class="control__indicator"></div>' +
            '        </label>';
        }
        else {
            trainingContainerClass = '';
        }

        let brandOptions = getScenarioEditorInputOptions('brands', companyData);
        let talentOptions = getScenarioEditorInputOptions('talent', companyData);

        inputsHtml =
            '<div class="column-left">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Name</div>' +
            '        <input type="text" class="styled-input scenario-editor-name-input"' +
            '               data-attribute="name" maxlength="50" tabindex="1">' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Age</div>' +
            '        <input type="number" class="styled-input scenario-editor-age-input"' +
            '               data-attribute="age" tabindex="3" min="10" max="100">' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Charisma</div>' +
            '        <select class="styled-select scenario-editor-charisma-select" tabindex="5" ' +
            '                data-attribute="charisma">' +
            '            <option value="1" selected>1</option>' +
            '            <option value="2">2</option>' +
            '            <option value="3">3</option>' +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Alignment</div>' +
            '        <select class="styled-select scenario-editor-alignment-select" tabindex="7" ' +
            '                data-attribute="alignment">' +
            '            <option value="" selected>Neutral</option>' +
            '            <option value="face">Face</option>' +
            '            <option value="heel">Heel</option>' +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-20">' +
            '        <div class="display-block margin-bottom-2">Status</div>' +
            '        <select class="styled-select scenario-editor-status-select" tabindex="9" ' +
            '                data-attribute="status">' +
            '            <option value="active">Active</option>' +
            '            <option value="part-timer">Part-timer</option>' +
            '            <option value="retired">Retired</option>' +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <label class="control control--checkbox">' +
            '            Gimmick' +
            '            <input type="checkbox" class="scenario-editor-gimmick-input" tabindex="11" data-attribute="gimmick"/>' +
            '            <div class="control__indicator"></div>' +
            '        </label>' +
            '        <div class="superstar-gimmick-container display-none margin-top-5">' +
            '            <div class="margin-bottom-8">' +
            '                <div class="display-block margin-bottom-2">Name</div>' +
            '                <input type="text" class="styled-input scenario-editor-gimmick-name-input" ' +
            '                        data-attribute="gimmick">' +
            '            </div>' +
            '            <div class="margin-bottom-20">' +
            '                <div class="display-block margin-bottom-2">Effectiveness</div>' +
            '                <select class="styled-select scenario-editor-gimmick-effectiveness-select" ' +
            '                        data-attribute="gimmick">' +
            '                    <option>Mark Out!</option>' +
            '                    <option>Good</option>' +
            '                    <option selected>Average</option>' +
            '                    <option>Not Good</option>' +
            '                    <option>Bad</option>' +
            '                </select>' +
            '            </div>' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <label class="control control--checkbox">' +
            '            Managed Talent' +
            '            <input type="checkbox" class="scenario-editor-manager-input" tabindex="13" data-attribute="managed_talent_names"/>' +
            '            <div class="control__indicator"></div>' +
            '        </label>' +
            '        <div class="superstar-manager-container display-none margin-top-3">' +
            '            <div class="margin-bottom-20">' +
            '                <div class="display-block margin-bottom-2">Talent</div>' +
            '                <div class="margin-bottom-8">' +
            '                    <select class="styled-select margin-top-2 scenario-editor-managed-talent-select"' +
            '                            tabindex="3" data-attribute="managed_talent_names">' +
                                     talentOptions +
            '                    </select>' +
            '                </div>' +
            '                <div>' +
            '                    <button type="button"' +
            '                            class="scenario-editor-add-managed-talent-button button retro-button styled-select-button">' +
            '                        <i class="fa fa-plus"></i>' +
            '                    </button>' +
            '                </div>' +
            '            </div>' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <label class="control control--checkbox help-text"' +
            '               title="Full-time managers are not usable in matches. They provide a boost to talent when appearing alongside them in segments.">' +
            '            Full-time Manager' +
            '            <input type="checkbox" class="styled-input scenario-editor-full-time-manager-input" ' +
            '                   data-attribute="full_time_manager"/>' +
            '            <div class="control__indicator"></div>' +
            '        </label>' +
            '    </div>' +
            '</div>' +

            '<div class="column-right">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Popularity</div>' +
            '        <input type="number" class="styled-input scenario-editor-popularity-input help-text"' +
            '               data-attribute="popularity" tabindex="2" min="0" max="1050" title="Main Eventer: 800+, Upper Midcarder: 600-799, Lower Midcarder: 400-599, Jabroni: 0-399">' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Pronoun</div>' +
            '        <select class="styled-select scenario-editor-pronoun-select margin-top-2" tabindex="4" ' +
            '                data-attribute="pronoun">' +
            '            <option value="he" selected>He</option>' +
            '            <option value="she">She</option>' +
            '            <option value="they">They</option>' +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">' +
            '            Workrate' +
            '        </div>' +
            '        <select class="styled-select scenario-editor-workrate-select" tabindex="6" data-attribute="workrate">' +
            '            <option value="1" selected>1</option>' +
            '            <option value="2">2</option>' +
            '            <option value="3">3</option>' +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Overness</div>' +
            '        <select class="styled-select scenario-editor-overness-select" tabindex="8" data-attribute="overness">' +
            '            <option>Over</option>' +
            '            <option>Popular</option>' +
            '            <option selected>Average</option>' +
            '            <option>Not Popular</option>' +
            '            <option>Stale</option>' +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-20">' +
            '        <div class="display-block margin-bottom-2">Brand</div>' +
            '        <select class="styled-select scenario-editor-brand-select" tabindex="10" data-attribute="brand_name">' +
                        brandOptions +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <label class="control control--checkbox">' +
            '            <div class="display-block margin-bottom-2">Injured</div>' +
            '            <input type="checkbox" class="scenario-editor-injured-input" tabindex="12" data-attribute="injured"/>' +
            '            <div class="control__indicator"></div>' +
            '        </label>' +
            '        <div class="display-block superstar-injured-months-container display-none margin-top-3">' +
            '            <div class="margin-bottom-20">' +
            '                <div class="display-block margin-bottom-2">Months</div>' +
            '                <input type="number" class="styled-input scenario-editor-injured-months-input" min="1" max="120" ' +
            '                   data-attribute="injured">' +
            '            </div>' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
                     trainingInput +
            '        <div class="superstar-future-container' + trainingContainerClass + '">' +
            '            <label class="control control--checkbox help-text"' +
            '                   title="Set this superstar to appear at a specified time after the game starts. They will appear at the age you set for them.">' +
            '                Future' +
            '                <input type="checkbox" class="styled-input scenario-editor-future-input" data-attribute="month_to_appear_in"/>' +
            '                <div class="control__indicator"></div>' +
            '            </label>' +
            '            <div class="superstar-future-inputs-container margin-top-6 display-none">' +
            '               <div class="scenario-editor-year-container">' +
            '                   <div class="display-block margin-bottom-2">Year</div>' +
            '                   <input type="number" class="styled-input scenario-editor-year-input" ' +
            '                          data-attribute="month_to_appear_in" min="0" max="200">' +
            '               </div>' +
            '               <div class="scenario-editor-month-container">' +
            '                   <div class="display-block margin-bottom-2">Month</div>' +
            '                   <input type="number" class="styled-input scenario-editor-month-input" ' +
            '                          data-attribute="month_to_appear_in" min="0" max="11">' +
            '               </div>' +
            '               <div class="clear"></div>' +
            '            </div>' +
            '        </div>' +
            '    </div>' +
            '    <div>' +
            '        <label class="control control--checkbox">' +
            '            Hall of Famer' +
            '            <input type="checkbox" class="scenario-editor-hall-of-famer-input" tabindex="14" ' +
            '                   data-attribute="hall_of_famer"/>' +
            '            <div class="control__indicator"></div>' +
            '        </label>' +
            '    </div>' +
            '</div>' +
            '<div class="clear"></div>' +

            '<div class="superstar-traits-selection-container margin-top-5">' +
            '    <div class="display-block">' +
            '        Traits' +
            '    </div>' +
            '    <div class="superstar-traits-selection-text font-1p125em line-height-24px light-grey">' +
            '        None' +
            '    </div>' +
            '    <input type="hidden" class="superstar-traits-selection-input" data-attribute="traits"/>' +
            '    <div class="superstar-traits-show-button margin-top-7">' +
            '        <span>Show Traits</span>' +
            '        <i class="fa fa-angle-down margin-left-3 font-14px"></i>' +
            '    </div>' +
            '    <div class="superstar-traits-information line-height-1p4 margin-top-3 light-grey display-none font-1p125em">' +
            '        Select a trait to display its details here' +
            '    </div>' +
            '</div>' +

            '<div class="superstar-trait-items-container margin-top-15 display-none">' +
            '    <div class="margin-bottom-5">' +
            '        <div class="display-block margin-bottom-5 font-1p125em">' +
            '            <span class="light-grey margin-left-3">Matches</span>' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Dull Worker">Ring General' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Ring General">Dull Worker' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">' +
            '            Workhorse' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Big Stage Wreck">Big Match Specialist' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Big Match Specialist,Weekly Sloth">Big Stage Wreck' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Big Stage Wreck">Weekly Sloth' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Hates Gimmick Matches">Enjoys Gimmick Matches' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Enjoys Gimmick Matches">Hates Gimmick Matches' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-5">' +
            '        <div class="display-block margin-bottom-5 font-1p125em">' +
            '            <span class="light-grey margin-left-3">Segments</span>' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">' +
            '            Entertainer' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="Humorless">' +
            '            Comedy Chops' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Comedy Chops">Humorless' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-5">' +
            '        <div class="display-block margin-bottom-5 font-1p125em">' +
            '            <span class="light-grey margin-left-3">Feuds</span>' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Neglects Story">Storyteller' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Storyteller">Neglects Story' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="Bad Actor">' +
            '            Good Actor' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Good Actor">Bad Actor' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-5">' +
            '        <div class="display-block margin-bottom-5 font-1p125em">' +
            '            <span class="light-grey margin-left-3">Overness/Alignment</span>' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Naturally Stale">Natural Charisma' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Natural Charisma">Naturally Stale' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Natural Heel">Natural Babyface' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Natural Babyface">Natural Heel' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-5">' +
            '        <div class="display-block margin-bottom-5 font-1p125em">' +
            '            <span class="light-grey margin-left-3">Progress</span>' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Slow Learner,Loves Training,Hates Training,Self Learner,Lacks Self Learning">' +
            '            Quick Learner' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Quick Learner,Loves Training,Hates Training,Self Learner,Lacks Self Learning">' +
            '            Slow Learner' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Hates Training,Quick Learner,Slow Learner">Loves' +
            '            Training' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Loves Training,Quick Learner,Slow Learner">Hates' +
            '            Training' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Lacks Self Learning,Quick Learner,Slow Learner">' +
            '            Self Learner' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Self Learner,Quick Learner,Slow Learner">Lacks' +
            '            Self Learning' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-5">' +
            '        <div class="display-block margin-bottom-5 font-1p125em">' +
            '            <span class="light-grey margin-left-3">Career</span>' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Lifelong Wrestler,Other Interests">Dedicated' +
            '            Wrestler' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Dedicated Wrestler,Other Interests">Lifelong' +
            '            Wrestler' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Dedicated Wrestler,Lifelong Wrestler">Other' +
            '            Interests' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-5">' +
            '        <div class="display-block margin-bottom-5 font-1p125em">' +
            '            <span class="light-grey margin-left-3">Morale</span>' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Hard To Please,Rebel,Loyal,Extreme Emotions">Easy' +
            '            To Please' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Easy To Please,Rebel,Loyal,Extreme Emotions">Hard' +
            '            To Please' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Rebel,Easy To Please,Hard To Please,Extreme Emotions">' +
            '            Loyal' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Loyal,Easy To Please,Hard To Please,Extreme Emotions">' +
            '            Rebel' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Easy To Please,Hard To Please,Rebel,Loyal">Extreme' +
            '            Emotions' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">Giving' +
            '            Veteran' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">Star' +
            '            Maker' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">Spotlight' +
            '            Lover' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-5">' +
            '        <div class="display-block margin-bottom-5 font-1p125em">' +
            '            <span class="light-grey margin-left-3">Holy Shit Moments</span>' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Risk Averse">Risk Taker' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Risk Taker,Gifted Acrobat">Risk Averse' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Risk Averse">Gifted Acrobat' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">Stiff' +
            '            Worker' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-5">' +
            '        <div class="display-block margin-bottom-5 font-1p125em">' +
            '            <span class="light-grey margin-left-3">Injuries</span>' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Injury Prone">Injury Resilient' +
            '        </div>' +
            '        <div class="superstar-trait-item-container"' +
            '             data-conflicting-traits="Injury Resilient">Injury Prone' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">Dangerous' +
            '            Worker' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-5">' +
            '        <div class="display-block margin-bottom-5 font-1p125em">' +
            '            <span class="light-grey margin-left-3">Gimmicks</span>' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">Character' +
            '            Worker' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">Lore' +
            '            Master' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">Redeems' +
            '            Bad Gimmicks' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-5">' +
            '        <div class="display-block margin-bottom-5 font-1p125em">' +
            '            <span class="light-grey margin-left-3">Backstage</span>' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">Leader' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">' +
            '            Troublemaker' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">Drug' +
            '            Habit' +
            '        </div>' +
            '    </div>' +
            '    <div class="margin-bottom-5">' +
            '        <div class="display-block margin-bottom-5 font-1p125em">' +
            '            <span class="light-grey margin-left-3">Misc</span>' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">Bleeder' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">Tag Team' +
            '            Specialist' +
            '        </div>' +
            '        <div class="superstar-trait-item-container" data-conflicting-traits="">Ages' +
            '            Well' +
            '        </div>' +
            '    </div>' +
            '</div>' +

            '<button type="button" class="button retro-button grey-button-background condensed remove-outline' +
            '                                add-scenario-editor-superstar-graphic add-graphic-button margin-top-15 margin-right-5 no-margin-bottom">Add Graphic' +
            '</button>' +
            '<button type="button" class="button retro-button grey-button-background condensed remove-outline' +
            '                                remove-scenario-editor-graphic-button display-none margin-top-15 no-margin-bottom">Remove Graphic' +
            '</button>' +
            '<input type="hidden" class="scenario-editor-graphic-input" data-attribute="graphic"/>' +

            '<div class="character-creator display-none">' +
            '    <div class="margin-top-10 margin-bottom-15 superstar-graphic"></div>' +
            '    <div class="character-creator-controls">' +
            '        <div>' +
            '            <div class="margin-bottom-10 select-part">' +
            '                <div class="margin-bottom-8">' +
            '                    <div class="margin-bottom-2">Attire</div>' +
            '                    <button type="button" class="button retro-button grey-button-background' +
            '                                                    condensed remove-outline attire-select-button no-select selected">A' +
            '                    </button>' +
            '                    <button type="button" class="button retro-button grey-button-background' +
            '                                                    condensed remove-outline attire-select-button no-select">B' +
            '                    </button>' +
            '                    <button type="button" class="button retro-button grey-button-background' +
            '                                                    condensed remove-outline attire-select-button no-select">C' +
            '                    </button>' +
            '                </div>' +
            '                <div>' +
            '                    <button type="button" class="button retro-button red-button-background' +
            '                                                    condensed remove-outline remove-attire-button no-select">Remove' +
            '                        Attire' +
            '                    </button>' +
            '                </div>' +
            '                <div class="margin-bottom-5">' +
            '                    <button type="button" class="button retro-button orange-button-background' +
            '                                                    condensed remove-outline preset-1 no-select">' +
            '                        Preset 1' +
            '                    </button>' +
            '                    <button type="button" class="button retro-button orange-button-background' +
            '                                                    condensed remove-outline preset-2 no-select">' +
            '                        Preset 2' +
            '                    </button>' +
            '                </div>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline margin-bottom-1">Body' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Eyes' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Hair' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Facial Hair' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Torso' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline margin-bottom-1">Bottoms' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Shoes' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Elbow' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Knee' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Accessory' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Tattoo' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Facepaint' +
            '                </button>' +
            '                <div class="font-bold select-accessory-number margin-top-5">' +
            '                </div>' +
            '                <div class="font-bold select-sub-category margin-top-10">' +
            '                </div>' +
            '            </div>' +
            '            <div class="font-bold part-controls margin-bottom-20">' +
            '                <div class="margin-bottom-5 display-inline-block margin-right-15">' +
            '                    <span class="margin-right-5 light-grey">Style</span>' +
            '                    <i class="fa fa-angle-double-left select-previous cursor-pointer"></i>' +
            '                    <span class="selection-number font-1p125em text-center">1</span>' +
            '                    <i class="fa fa-angle-double-right select-next cursor-pointer"></i>' +
            '                </div>' +
            '                <div class="display-inline-block">' +
            '                    <span class="margin-right-5 light-grey">Color</span>' +
            '                    <input type="text" class="spectrum"/>' +
            '                </div>' +
            '                <div class="select-design-holder">' +
            '                    <div class="select-design">' +
            '                        <button type="button"' +
            '                                class="button retro-button micro grey-button-background remove-outline display-none">' +
            '                            1' +
            '                        </button>' +
            '                        <button type="button"' +
            '                                class="button retro-button micro grey-button-background remove-outline display-none">' +
            '                            2' +
            '                        </button>' +
            '                        <button type="button"' +
            '                                class="button retro-button micro grey-button-background remove-outline display-none">' +
            '                            3' +
            '                        </button>' +
            '                        <button type="button"' +
            '                                class="button retro-button micro grey-button-background remove-outline display-none">' +
            '                            4' +
            '                        </button>' +
            '                    </div>' +
            '                </div>' +
            '            </div>' +
            '            <div class="character-creator-menu">' +
            '                <button type="button"' +
            '                        class="button retro-button condensed grey-button-background remove-outline share-character no-margin-bottom">' +
            '                    Share' +
            '                </button>' +
            '                <button type="button"' +
            '                        class="button retro-button condensed grey-button-background remove-outline import-character no-margin-bottom">' +
            '                    Import' +
            '                </button>' +
            '                <button type="button"' +
            '                        class="button retro-button condensed grey-button-background remove-outline randomize-character no-margin-bottom">' +
            '                    Randomize' +
            '                </button>' +
            '                <button type="button"' +
            '                        class="button retro-button condensed grey-button-background remove-outline search-graphics no-margin-bottom">' +
            '                    Search' +
            '                </button>' +
            '            </div>' +
            '            <div class="display-none load-character-code-container">' +
            '                <input type="text"' +
            '                       class="character-code-input load-character-code-input styled-input"' +
            '                       placeholder="Add Character Code">' +
            '                <button type="button" class="button retro-button grey-button-background remove-outline margin-top-10' +
            '                                                condensed load-character-code-button margin-left-1">Load' +
            '                </button>' +
            '            </div>' +
            '            <div class="display-none share-character-code-container">' +
            '                <input name="superstar-code" type="text"' +
            '                       class="character-code-input share-character-code-input styled-input">' +
            '                <button type="button" class="button retro-button grey-button-background remove-outline margin-top-10' +
            '                                                condensed copy-character-code margin-left-1">Copy' +
            '                </button>' +
            '            </div>' +
            '            <div class="display-none randomize-character-container">' +
            '                <button type="button"' +
            '                        class="button retro-button grey-button-background condensed remove-outline margin-top-10' +
            '                                            randomize-character-button">Masculine' +
            '                </button>' +
            '                <button type="button"' +
            '                        class="button retro-button grey-button-background condensed remove-outline margin-top-10' +
            '                                            randomize-character-button">Feminine' +
            '                </button>' +
            '                <button type="button"' +
            '                        class="button retro-button grey-button-background condensed remove-outline margin-top-10' +
            '                                            randomize-character-button">Any' +
            '                </button>' +
            '                <button type="button"' +
            '                        class="button retro-button grey-button-background condensed remove-outline margin-top-10' +
            '                                            randomize-character-button">Clothes' +
            '                </button>' +
            '            </div>' +
            '            <div class="graphics-search-container font-bold display-none">' +
            '                <div>' +
            '                    <input type="text" name="graphics-search-input-name"' +
            '                           class="styled-input graphics-search-input-name"' +
            '                           placeholder="Name"' +
            '                           autocomplete="off">' +
            '                    <button type="button" class="button retro-button remove-outline margin-top-10 graphics-search-button' +
            '                                                    condensed grey-button-background margin-left-1">Search' +
            '                    </button>' +
            '                </div>' +
            '                <div class="graphics-search-results display-none text-left margin-top-10">' +
            '                    <div class="graphics-search-results-number light-grey margin-left-2' +
            '                                                    display-inline-block"></div>' +
            '                    <div class="graphics-search-sort-buttons float-right">' +
            '                        <button type="button" class="button retro-button condensed light-button-background' +
            '                                                        graphics-search-sort-results-button selected">Best' +
            '                        </button>' +
            '                        <button type="button" class="button retro-button condensed light-button-background' +
            '                                                        graphics-search-sort-results-button">New' +
            '                        </button>' +
            '                    </div>' +
            '                    <div class="graphics-search-results-container inner-box display-none' +
            '                                                    margin-top-5 compact"></div>' +
            '                    <div class="graphics-pagination-buttons margin-top-10 display-none">' +
            '                        <div class="column-left">' +
            '                            <button type="button" class="button retro-button condensed light-button-background' +
            '                                                            graphics-previous-page-button">' +
            '                                Prev' +
            '                            </button>' +
            '                        </div>' +
            '                        <div class="column-right text-right">' +
            '                            <button type="button" class="button retro-button condensed light-button-background' +
            '                                                             graphics-next-page-button">' +
            '                                Next' +
            '                            </button>' +
            '                        </div>' +
            '                        <div class="clear"></div>' +
            '                    </div>' +
            '                </div>' +
            '            </div>' +
            '        </div>' +
            '    </div>' +
            '</div>';
    }
    else if (itemType === 'teams') {
        let superstarOptions = getScenarioEditorInputOptions('current-superstars', companyData, false);
        inputsHtml =
            '<div class="column-left">' +
            '    <div class="margin-bottom-15">' +
            '        <div class="display-block margin-bottom-2">Team Name</div>' +
            '        <input type="text" class="styled-input scenario-editor-name-input"' +
            '               data-attribute="name" maxlength="50" tabindex="1">' +
            '    </div>' +
            '    <div>' +
            '        <div class="display-block margin-bottom-2">First Superstar</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-first-superstar-select" tabindex="3" ' +
            '                data-attribute="superstars">' +
                        superstarOptions +
            '        </select>' +
            '    </div>' +
            '    <div class="display-none margin-top-15">' +
            '        <div class="display-block margin-bottom-2">Third Superstar</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-third-superstar-select" tabindex="5" ' +
            '                data-attribute="superstars">' +
                        superstarOptions +
            '        </select>' +
            '    </div>' +
            '</div>' +
            '<div class="column-right">' +
            '    <div class="margin-bottom-15">' +
            '        <div class="display-block margin-bottom-2">Team Type</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-team-type-select" tabindex="2" ' +
            '                data-attribute="team_type">' +
            '            <option value="tag-team" selected>Tag Team</option>' +
            '            <option value="trio">Trio</option>' +
            '        </select>' +
            '    </div>' +
            '    <div>' +
            '        <div class="display-block margin-bottom-2">Second Superstar</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-second-superstar-select" tabindex="3" ' +
            '                data-attribute="superstars">' +
                        superstarOptions +
            '        </select>' +
            '    </div>' +
            '</div>' +
            '<div class="clear"></div>';
    }
    else if (itemType === 'factions') {
        let memberOptions = getScenarioEditorInputOptions('current-superstars', companyData);
        inputsHtml =
            '<div class="column-left">' +
            '    <div class="margin-bottom-15">' +
            '        <div class="display-block margin-bottom-2">Faction Name</div>' +
            '        <input type="text" class="styled-input scenario-editor-name-input"' +
            '               data-attribute="name" maxlength="50" tabindex="1">' +
            '    </div>' +
            '    <div class="margin-bottom-8">' +
            '        <div class="display-block margin-bottom-2">Members</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-faction-member-select"' +
            '                tabindex="3" data-attribute="superstars">' +
                        memberOptions +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-8">' +
            '        <select class="styled-select margin-top-2 scenario-editor-faction-member-select"' +
            '                tabindex="3" data-attribute="superstars">' +
                        memberOptions +
            '        </select>' +
            '    </div>' +
            '    <div>' +
            '        <button type="button"' +
            '                class="scenario-editor-add-faction-member-button button retro-button styled-select-button">' +
            '            <i class="fa fa-plus"></i>' +
            '        </button>' +
            '    </div>' +
            '</div>' +
            '<div class="column-right">' +
            '    <div class="margin-bottom-15">' +
            '        <div class="display-block margin-bottom-2">Reputation</div>' +
            '        <input type="number" class="styled-input scenario-editor-reputation-input" tabindex="2" ' +
            '               data-attribute="reputation" min="1" max="10">' +
            '    </div>' +
            '    <div>' +
            '        <div class="display-block margin-bottom-2">Leader</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-faction-leader-select"' +
            '                tabindex="4" data-attribute="leader_superstar">' +
            '        </select>' +
            '    </div>' +
            '</div>' +
            '<div class="clear"></div>';
    }
    else if (itemType === 'events') {
        let brandOptions = getScenarioEditorInputOptions('brands', companyData);
        inputsHtml =
            '<div class="column-left">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Event Name</div>' +
            '        <input type="text" class="styled-input scenario-editor-name-input"' +
            '               data-attribute="name" maxlength="50" tabindex="1">' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Weekly Show Before Event</div>' +
            '        <input type="text" class="styled-input scenario-editor-weekly-show-before-event-input help-text" ' +
            '               title="Optional: Enter a custom name for the weekly show before this event" tabindex="3" ' +
            '               data-attribute="weekly_show_before_name">' +
            '    </div>' +
            '    <div>' +
            '        <div class="display-block margin-bottom-2">Brand</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-brand-select" tabindex="5" ' +
            '                data-attribute="brand_name">' +
                        brandOptions +
            '        </select>' +
            '    </div>' +
            '</div>' +
            '<div class="column-right">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Prestige</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-prestige-select" tabindex="2" ' +
            '                data-attribute="prestige">' +
            '            <option>A</option>' +
            '            <option>B</option>' +
            '            <option selected>C</option>' +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Weekly Show After Event</div>' +
            '        <input type="text" class="styled-input scenario-editor-weekly-show-after-event-input help-text" ' +
            '               title="Optional: Enter a custom name for the weekly show after this event" tabindex="4" ' +
            '               data-attribute="weekly_show_after_name">' +
            '    </div>' +
            '</div>' +
            '<div class="clear"></div>';
    }
    else if (itemType === 'championships') {

        // Get champion options based on championship division
        let championOptions;
        if (object.division === 'tag-team') {
            championOptions = getScenarioEditorInputOptions('teams', companyData)
        }
        else if (object.division === 'trio') {
            championOptions = getScenarioEditorInputOptions('trios', companyData)
        }
        else {
            championOptions = getScenarioEditorInputOptions('main-roster-current-superstars', companyData)
        }

        let brandOptions = getScenarioEditorInputOptions('brands', companyData);
        inputsHtml =
            '<div class="column-left">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Championship Name</div>' +
            '        <input type="text" class="styled-input scenario-editor-name-input"' +
            '               data-attribute="name" maxlength="50" tabindex="1">' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Champion</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-champion-select" tabindex="3" ' +
            '                data-attribute="champion">' +
                         championOptions +
            '        </select>' +
            '    </div>' +
            '    <div>' +
            '        <div class="display-block margin-bottom-2">Rank</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-rank-select" tabindex="5" ' +
            '                data-attribute="rank">' +
            '            <option value="Main Eventer" selected>Main Event</option>' +
            '            <option value="Upper Midcarder">Upper Midcard</option>' +
            '            <option value="Lower Midcarder">Lower Midcard</option>' +
            '            <option value="Jabroni">Jabroni</option>' +
            '        </select>' +
            '    </div>' +
            '</div>' +
            '<div class="column-right">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Division</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-division-select" tabindex="2" ' +
            '                data-attribute="division">' +
            '            <option value="singles" selected>Singles</option>' +
            '            <option value="tag-team">Tag Team</option>' +
            '            <option value="trio">Trios</option>' +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Prestige</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-prestige-select" tabindex="4" ' +
            '                data-attribute="prestige">' +
            '            <option value="A">Gold</option>' +
            '            <option value="B">Silver</option>' +
            '            <option value="C" selected>Bronze</option>' +
            '        </select>' +
            '    </div>' +
            '    <div>' +
            '        <div class="display-block margin-bottom-2">Brand</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-brand-select" tabindex="6" ' +
            '                data-attribute="brand_name">' +
                         brandOptions +
            '        </select>' +
            '    </div>' +
            '</div>' +
            '<div class="clear"></div>' +

            '<button type="button" class="button retro-button grey-button-background condensed remove-outline' +
            '                                add-scenario-editor-championship-graphic add-graphic-button margin-top-20 margin-right-5 no-margin-bottom">Add Graphic' +
            '</button>' +
            '<button type="button" class="button retro-button grey-button-background condensed remove-outline' +
            '                                remove-scenario-editor-graphic-button display-none margin-top-20 no-margin-bottom">Remove Graphic' +
            '</button>' +
            '<input type="hidden" class="scenario-editor-graphic-input" data-attribute="graphic"/>' +

            '<div class="character-creator display-none">' +
            '    <div class="margin-top-10 margin-bottom-15 superstar-graphic"></div>' +
            '    <div class="character-creator-controls">' +
            '        <div>' +
            '            <div class="margin-bottom-10 select-part">' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Center Plate' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Strap' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Side Plates' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Center Gems' +
            '                </button>' +
            '                <button type="button" class="button retro-button condensed part-button dark-grey-button-background' +
            '                                                remove-outline">Side Gems' +
            '                </button>' +
            '            </div>' +
            '            <div class="font-bold part-controls margin-bottom-20">' +
            '                <div class="margin-bottom-5 display-inline-block margin-right-15">' +
            '                    <span class="margin-right-5 light-grey">Style</span>' +
            '                    <i class="fa fa-angle-double-left select-previous cursor-pointer"></i>' +
            '                    <span class="selection-number font-1p125em text-center">1</span>' +
            '                    <i class="fa fa-angle-double-right select-next cursor-pointer"></i>' +
            '                </div>' +
            '                <div class="display-inline-block">' +
            '                    <span class="margin-right-5 light-grey">Color</span>' +
            '                    <input type=\'text\' class="spectrum"/>' +
            '                </div>' +
            '                <div class="select-design-holder">' +
            '                    <div class="select-design">' +
            '                        <button type="button"' +
            '                                class="button retro-button micro grey-button-background remove-outline display-none">' +
            '                            1' +
            '                        </button>' +
            '                        <button type="button"' +
            '                                class="button retro-button micro grey-button-background remove-outline display-none">' +
            '                            2' +
            '                        </button>' +
            '                        <button type="button"' +
            '                                class="button retro-button micro grey-button-background remove-outline display-none">' +
            '                            3' +
            '                        </button>' +
            '                        <button type="button"' +
            '                                class="button retro-button micro grey-button-background remove-outline display-none">' +
            '                            4' +
            '                        </button>' +
            '                    </div>' +
            '                </div>' +
            '            </div>' +
            '            <div class="character-creator-menu">' +
            '                <button type="button"' +
            '                        class="button retro-button condensed grey-button-background remove-outline share-character no-margin-bottom">' +
            '                    Share' +
            '                </button>' +
            '                <button type="button"' +
            '                        class="button retro-button condensed grey-button-background remove-outline import-character no-margin-bottom">' +
            '                    Import' +
            '                </button>' +
            '                <button type="button"' +
            '                        class="button retro-button condensed grey-button-background remove-outline randomize-character no-margin-bottom">' +
            '                    Randomize' +
            '                </button>' +
            '            </div>' +
            '            <div class="display-none load-character-code-container">' +
            '                <input type="text"' +
            '                       class="character-code-input load-character-code-input styled-input"' +
            '                       placeholder="Add Character Code">' +
            '                <button type="button" class="button retro-button grey-button-background remove-outline margin-top-10' +
            '                                                condensed load-character-code-button">Load' +
            '                </button>' +
            '            </div>' +
            '            <div class="display-none share-character-code-container">' +
            '                <input name="superstar-code" type="text"' +
            '                       class="character-code-input share-character-code-input styled-input">' +
            '                <button type="button" class="button retro-button grey-button-background remove-outline margin-top-10' +
            '                                                condensed copy-character-code">Copy' +
            '                </button>' +
            '            </div>' +
            '        </div>' +
            '    </div>' +
            '</div>';
    }
    else if (itemType === 'gimmick-matches') {

        inputsHtml =
            '<div class="column-left">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Match Name</div>' +
            '        <input type="text" class="styled-input scenario-editor-name-input"' +
            '               data-attribute="name" maxlength="50" tabindex="1">' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Rating</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-rating-select" tabindex="3" ' +
            '                data-attribute="rating_boost">' +
            '            <option value="1">Low</option>' +
            '            <option value="2" selected>Med</option>' +
            '            <option value="3">High</option>' +
            '            <option value="4">Highest</option>' +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Consequence</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-consequence-select help-text"' +
            '                tabindex="5" title="Championship contract: Awards a championship contract to the winner that can be cashed in anytime for a championship match.' +
            '                                    Match Contract: Awards a contract for a match to the winner that can be used at a fixed event." ' +
            '                data-attribute="consequence">' +
            '            <option value="" selected>None</option>' +
            '            <option value="championship_contract">Championship Contract</option>' +
            '            <option value="match_contract">Fixed Match Contract</option>' +
            '            <option value="loser_unavailable">Loser Unavailable</option>' +
            '            <option value="random_opponent">Random Opponent</option>' +
            '            <option value="remove_hair">Remove Hair</option>' +
            '            <option value="remove_mask">Remove Mask</option>' +
            '            <option value="remove_mask_or_hair">Remove Mask or Hair</option>' +
            '            <option value="add_hair">Add Hair</option>' +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-top-12 margin-bottom-12 scenario-editor-contract-name-container display-none">' +
            '        <div class="display-block margin-bottom-2">Contract Name</div>' +
            '        <input type="text" class="styled-input scenario-editor-contract-name-input" tabindex="6" ' +
            '                data-attribute="contract_name">' +
            '    </div>' +
            '    <div class="margin-bottom-15">' +
            '        <div class="display-block margin-bottom-2">Graphic Type</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-graphic-type-select help-text"' +
            '                tabindex="7" data-attribute="graphic_type" title="A unique graphic will be displayed for this gimmick match. (Early Access)">' +
            '            <option value="" selected>None</option>' +
            '            <option value="ladder">Ladder (Any)</option>' +
            '            <option value="ladder_black">Ladder (Black)</option>' +
            '            <option value="ladder_grey">Ladder (Grey)</option>' +
            '            <option value="ladder_orange">Ladder (Orange)</option>' +
            '            <option value="cage_grey">Cage (Grey)</option>' +
            '            <option value="cage_red">Cage (Red)</option>' +
            '            <option value="cage_retro_blue">Cage (Retro Blue)</option>' +
            '            <option value="cage_retro_black">Cage (Retro Black)</option>' +
            '            <option value="table">Tables</option>' +
            '            <option value="chair">Chairs</option>' +
            '            <option value="tables_ladders_chairs">Tables Ladders & Chairs</option>' +
            '            <option value="ambulance">Ambulance</option>' +
            '            <option value="barbed_wire_ropes">Barbed Wire Ropes</option>' +
            '            <option value="casket">Casket</option>' +
            '            <option value="grave">Grave</option>' +
            '            <option value="parking_lot">Parking Lot</option>' +
            '        </select>' +
            '    </div>' +
            '    <div>' +
            '        <label class="control control--checkbox help-text" title="Participants will hold random weapons in this gimmick match. (Early Access)">' +
            '            Add Random Weapons' +
            '            <input type="checkbox" class="scenario-editor-add-random-weapons-input" tabindex="8" ' +
            '                   data-attribute="add_random_weapons"/>' +
            '            <div class="control__indicator"></div>' +
            '        </label>' +
            '    </div>' +
            '</div>' +
            '<div class="column-right">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Rules</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-rules-select" tabindex="2" ' +
            '                data-attribute="rules">' +
            '            <option value="" selected>Normal</option>' +
            '            <option value="battle_royal">Battle Royal</option>' +
            '            <option value="elimination">Elimination</option>' +
            '            <option value="2/3_falls">2/3 Falls</option>' +
            '            <option value="special_referee">Special Referee</option>' +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Injury Rate</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-injury-rate-select" tabindex="4" ' +
            '                data-attribute="injury_rate">' +
            '            <option value="1">Low</option>' +
            '            <option value="2" selected>Med</option>' +
            '            <option value="3">High</option>' +
            '            <option value="4">Highest</option>' +
            '        </select>' +
            '    </div>' +
            '    <div>' +
            '        <div class="display-block margin-bottom-2">Description</div>' +
            '        <textarea class="styled-input scenario-editor-description-input help-text" ' +
            '                  title="Optional" tabindex="6" data-attribute="description"></textarea>' +
            '    </div>' +
            '</div>' +
            '<div class="clear"></div>';
    }
    else if (itemType === 'brands') {
        inputsHtml =
            '<div class="column-left">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Brand Name</div>' +
            '        <input type="text" class="styled-input scenario-editor-name-input"' +
            '               data-attribute="name" maxlength="50" tabindex="1">' +
            '    </div>' +
            '    <div class="margin-bottom-18">' +
            '        <div class="display-block margin-bottom-2">Overness</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-overness-select" tabindex="3" ' +
            '                data-attribute="overness">' +
            '            <option>Hot</option>' +
            '            <option selected>Popular</option>' +
            '            <option>Average</option>' +
            '            <option>Not Popular</option>' +
            '            <option>Stale</option>' +
            '        </select>' +
            '    </div>' +
            '    <div>' +
            '        <label class="control control--checkbox">' +
            '            Exclusive Weekly Show' +
            '            <input type="checkbox" class="scenario-editor-exclusive-weekly-show-input" tabindex="5" ' +
            '                   data-attribute="weekly_show_is_exclusive"/>' +
            '            <div class="control__indicator"></div>' +
            '        </label>' +
            '    </div>' +
            '</div>' +

            '<div class="column-right">' +
            '    <div class="margin-bottom-15">' +
            '        <div class="display-block margin-bottom-2">Weekly Show Name</div>' +
            '        <input type="text" class="styled-input scenario-editor-weekly-show-name-input"  tabindex="2" ' +
            '               data-attribute="weekly_show_name">' +
            '    </div>' +
            '    <div>' +
            '        <div class="display-block help-text margin-bottom-2"' +
            '             title="Adding a brand color will overwrite the default color across light/dark mode.">' +
            '            Color' +
            '        </div>' +
            '        <input type="text" class="scenario-editor-color-input" value="" autocomplete="off" tabindex="4" ' +
            '               data-attribute="color"/>' +
            '        <span class="scenario-editor-color-preview">Preview</span>' +
            '    </div>' +
            '</div>' +
            '<div class="clear"></div>';
    }
    else if (itemType === 'streaks') {
        let eventOptions = getScenarioEditorInputOptions('events', companyData, false);
        let talentOptions = getScenarioEditorInputOptions('talent', companyData, false);
        inputsHtml =
            '<div class="column-left">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Event</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-event-select" tabindex="1" data-attribute="event">' +
                        eventOptions +
            '        </select>' +
            '    </div>' +
            '    <div>' +
            '        <div class="display-block margin-bottom-2">Length (Years)</div>' +
            '        <input type="number" class="styled-input scenario-editor-length-input" tabindex="3" data-attribute="length" ' +
            '               min="1" max="100">' +
            '    </div>' +
            '</div>' +
            '<div class="column-right">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Talent</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-talent-select" tabindex="2" data-attribute="talent">' +
                        talentOptions +
            '        </select>' +
            '    </div>' +
            '</div>' +
            '<div class="clear"></div>';
    }
    else if (itemType === 'match-contracts') {
        let eventOptions = getScenarioEditorInputOptions('events', companyData, false);
        let talentOptions = getScenarioEditorInputOptions('talent', companyData, false);
        inputsHtml =
            '<div class="column-left">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Name</div>' +
            '        <input type="text" class="styled-input scenario-editor-name-input"' +
            '               data-attribute="name" maxlength="50" tabindex="1">' +
            '    </div>' +
            '    <div>' +
            '        <div class="display-block margin-bottom-2">Talent</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-talent-select" tabindex="3" data-attribute="talent">' +
                        talentOptions +
            '        </select>' +
            '    </div>' +
            '</div>' +
            '<div class="column-right">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Event</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-event-select" tabindex="2" data-attribute="event">' +
                        eventOptions +
            '        </select>' +
            '    </div>' +
            '</div>' +
            '<div class="clear"></div>';
    }
    else if (itemType === 'company-details') {
        let eventOptions = getScenarioEditorInputOptions('events', companyData, false);
        inputsHtml =
            '<div class="column-left">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Company Name</div>' +
            '        <input type="text" class="styled-input scenario-editor-name-input"' +
            '               data-attribute="name" maxlength="50" tabindex="1">' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Style</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-style-select" tabindex="3" ' +
            '                data-attribute="style">' +
            '            <option value="entertainment">Entertainment</option>' +
            '            <option value="pure">Pure</option>' +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Owner Name</div>' +
            '        <input type="text" class="styled-input scenario-editor-owner-name-input" tabindex="5" ' +
            '               data-attribute="owner_name">' +
            '    </div>' +
            '    <div>' +
            '        <div class="display-block margin-bottom-2">Top Event</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-top-event-select" tabindex="7" ' +
            '                data-attribute="top_event">' +
                        eventOptions +
            '</select>' +
            '    </div>' +
            '</div>' +

            '<div class="column-right">' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Reputation</div>' +
            '        <input type="number" class="styled-input scenario-editor-reputation-input" tabindex="2" ' +
            '               data-attribute="reputation" min="1" max="10">' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Creative Points</div>' +
            '        <input type="number" class="styled-input scenario-editor-creative-points-input" tabindex="4" ' +
            '               data-attribute="creative_points" min="0" max="5000">' +
            '    </div>' +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Weekly Show Name</div>' +
            '        <input type="text" class="styled-input scenario-editor-weekly-show-name-input" tabindex="6" ' +
            '               data-attribute="weekly_show_name">' +
            '    </div>' +
            '    <div>' +
            '        <div class="display-block margin-bottom-2">Overness</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-overness-select"' +
            '                tabindex="8" data-attribute="overness">' +
            '            <option>Hot</option>' +
            '            <option>Popular</option>' +
            '            <option selected="">Average</option>' +
            '            <option>Not Popular</option>' +
            '            <option>Stale</option>' +
            '        </select>' +
            '    </div>' +
            '</div>' +
            '<div class="clear"></div>';
    }
    else if (itemType === 'scenario-details') {
        let scenarioType = object.scenario_type;
        let scenarioNameHtml = '';
        let scenarioDescriptionHtml = '';
        let scenarioCommentsHtml = '';
        let allowEditsHtml = '';
        let allowSharingHtml = '';
        let privateElementClass = '';
        if (scenarioType === 'scenario') {
            scenarioNameHtml =
                '    <div class="margin-bottom-12">' +
                '        <div class="display-block margin-bottom-2">Scenario Name</div>' +
                '        <input type="text" class="styled-input scenario-editor-name-input"' +
                '               data-attribute="name" maxlength="50" tabindex="1">' +
                '    </div>';
            scenarioDescriptionHtml =
                '    <div class="margin-bottom-12">' +
                '        <div class="display-block margin-bottom-2">Description</div>' +
                '        <textarea class="styled-input scenario-editor-description-input" tabindex="2" data-attribute="description" maxlength="300"></textarea>' +
                '    </div>';
            scenarioCommentsHtml =
                '    <div class="margin-bottom-12">' +
                '        <div class="display-block margin-bottom-2">Version Comments</div>' +
                '        <textarea class="styled-input scenario-editor-comments-input" tabindex="3" data-attribute="comments"></textarea>' +
                '    </div>';
            allowEditsHtml =
                '    <div class="margin-bottom-10">' +
                '        <label class="control control--checkbox">' +
                '            Allow Edits' +
                '            <input type="checkbox" class="scenario-editor-allow-edits-input" tabindex="8" data-attribute="allow_edits"/>' +
                '            <div class="control__indicator"></div>' +
                '        </label>' +
                '    </div>';
            allowSharingHtml =
                '    <div>' +
                '        <label class="control control--checkbox help-text" ' +
                '               title="Shared scenarios will be available for other users to add to their scenarios as competitors">' +
                '            Allow Sharing' +
                '            <input type="checkbox" class="scenario-editor-allow-sharing-input" tabindex="9" data-attribute="allow_sharing"/>' +
                '            <div class="control__indicator"></div>' +
                '        </label>' +
                '    </div>';
            privateElementClass = 'margin-bottom-10';
        }
        else if (scenarioType === 'scenario_edit') {
            scenarioCommentsHtml =
                '    <div class="margin-bottom-12">' +
                '        <div class="display-block margin-bottom-2">Edit Name</div>' +
                '        <input type="text" class="styled-input scenario-editor-comments-input" tabindex="3" data-attribute="comments" data-edit-name="true">' +
                '    </div>';
        }

        let eventOptions = getScenarioEditorInputOptions('events', companyData, false);
        inputsHtml =
            '<div class="column-left">' +
                 scenarioNameHtml +
                 scenarioCommentsHtml +
            '    <div class="margin-bottom-20">' +
            '        <div class="display-block margin-bottom-2">Starting Year</div>' +
            '        <input type="number" class="styled-input scenario-editor-starting-year-input" tabindex="5" ' +
            '               data-attribute="starting_year" min="0" max="1000000">' +
            '    </div>' +
            '    <div class="' + privateElementClass + '">' +
            '        <label class="control control--checkbox">' +
            '            Private' +
            '            <input type="checkbox" class="scenario-editor-private-input" tabindex="7" data-attribute="private"/>' +
            '            <div class="control__indicator"></div>' +
            '        </label>' +
            '    </div>' +
                 allowSharingHtml +
            '</div>' +

            '<div class="column-right">' +
                 scenarioDescriptionHtml +
            '    <div class="margin-bottom-12">' +
            '        <div class="display-block margin-bottom-2">Market Size</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-market-size-select"' +
            '                tabindex="4" data-attribute="market_size">' +
            '            <option value="1000000">1 million</option>' +
            '            <option value="2000000">2 million</option>' +
            '            <option value="3000000">3 million</option>' +
            '            <option value="4000000" selected>4 million</option>' +
            '            <option value="5000000">5 million</option>' +
            '            <option value="8000000">8 million</option>' +
            '            <option value="10000000">10 million</option>' +
            '            <option value="12000000">12 million</option>' +
            '            <option value="15000000">15 million</option>' +
            '        </select>' +
            '    </div>' +
            '    <div class="margin-bottom-20">' +
            '        <div class="display-block margin-bottom-2">Starting Event</div>' +
            '        <select class="styled-select margin-top-2 scenario-editor-starting-event-select" tabindex="6" data-attribute="starting_event">' +
                        eventOptions +
            '        </select>' +
            '    </div>' +
                 allowEditsHtml +
            '</div>' +
            '<div class="clear"></div>'
    }
    else {
        inputsHtml = '<div class="margin-bottom-12">' +
        '<div class="display-block margin-bottom-2">Name</div>' +
        '<input type="text" class="styled-input scenario-editor-name-input" data-attribute="name" maxlength="50">' +
        '</div>';
    }

    return inputsHtml;
}

function getScenarioEditorInputOptions(itemType, companyData, addNoneOption) {
    if (typeof(addNoneOption) === 'undefined') addNoneOption = true;

    let optionsHtml = '';
    if (addNoneOption) {
        optionsHtml += '<option selected>None</option>'
    }

    // Get objects for options and sort
    let optionsObjects = getScenarioEditorItemObjects(companyData, itemType).slice();
    if (itemType !== 'events') {
        optionsObjects.sort(compareObjectNames)
    }

    // Add options with uid
    optionsObjects.forEach(function (optionObject) {
        optionsHtml += '<option data-uid="' + optionObject['uid'] + '">' + optionObject['name'] + '</option>'
    });

    return optionsHtml;
}

function getScenarioEditorItemObjects(companyData, itemType) {
    let objects;
    switch (itemType) {
        case 'superstars':
            objects = companyData['superstars'];
            break;
        case 'current-superstars':
            objects = companyData['superstars'].filter(function (superstar) {
                return !superstar['month_to_appear_in']
            });
            break;
        case 'main-roster-current-superstars':
            objects = companyData['superstars'].filter(function (superstar) {
                return !superstar['month_to_appear_in'] && !superstar['training']
            });
            break;
        case 'teams':
            objects = companyData['teams'];
            break;
        case 'trios':
            objects = companyData['teams'].filter(function (team) {
                return team['team_type'] === 'trio'
            });
            break;
        case 'talent':
            // Get teams and current superstars
            let currentSuperstars = companyData['superstars'].filter(function (superstar) {
                return !superstar['month_to_appear_in']
            });
            objects = companyData['teams'].concat(currentSuperstars);
            break;
        case 'factions':
            objects = companyData['factions'];
            break;
        case 'events':
            objects = companyData['events'];
            break;
        case 'championships':
            objects = companyData['championships'];
            break;
        case 'gimmick-matches':
            objects = companyData['gimmick_matches'];
            break;
        case 'brands':
            objects = companyData['brands'];
            break;
        case 'streaks':
            objects = companyData['streaks'];
            break;
        case 'match-contracts':
            objects = companyData['match_contracts'];
            break;
    }
    return objects;
}

function getScenarioEditorItemObject(itemObjects, itemUid) {
    // Get object by uid
    return itemObjects.filter(function (obj) {
        return obj.uid === itemUid;
    })[0];
}

function getScenarioEditorSelectedCompanyData(scenarioData) {
    let scenarioEditorContainer = $('.scenario-editor-container');
    let companyUid = scenarioEditorContainer.data('companyUid');
    let indies = scenarioEditorContainer.data('indies');
    return getScenarioEditorCompanyData(scenarioData, companyUid, indies);
}

function getScenarioEditorCompanyData(scenarioData, companyUid, indies) {
    let companyData;

    // Get indies
    if (indies) {
        companyData = scenarioData['indies'];
    }
    // Get company
    else {
        companyData = scenarioData['companies'].filter(function (obj) {
            return obj['company_details']['uid'] === companyUid;
        })[0];
    }

    return companyData
}

function loadScenarioEditorCompanyPage(companyData) {
    let parent = $('.scenario-editor-container');
    let indies = $('.scenario-editor-container').data('indies');

    // Set current page
    parent.data('previousPage', 'mainPage');

    // Unselect menu buttons
    $('.scenario-editor-menu-button.selected').removeClass('selected');

    // Add headers
    let companyNameHtml = (indies) ? 'Indies' : '{0} <span class="grey margin-left-2">Company</span>'.format(
        escapeHTML(companyData['company_details']['name']));
    if (parent.find('.scenario-editor-first-header').html() !== companyNameHtml) {
        parent.find('.scenario-editor-first-header').html(companyNameHtml).hide().fadeIn();
    }
    parent.find('.scenario-editor-second-header').text('');

    // Show/hide menu buttons
    parent.find('.scenario-editor-main-menu-container').hide();
    parent.find('.scenario-editor-companies-menu-container, .scenario-editor-companies-header').hide();

    // Show company/indies menu buttons
    if (indies) {
        parent.find('.scenario-editor-company-menu-container').hide();
        parent.find('.scenario-editor-indies-menu-container').fadeIn();
    }
    else {
        parent.find('.scenario-editor-company-menu-container').fadeIn();
        parent.find('.scenario-editor-indies-menu-container').hide();
    }

    // Hide list container
    parent.find('.scenario-editor-list-container, .scenario-editor-list-buttons-container, ' +
        '.scenario-editor-list-menu-container').hide();

    // Show/hide bottom buttons
    parent.find('.scenario-editor-publish-button').hide();
    parent.find('.scenario-editor-back-button').show();
    parent.find('.scenario-editor-main-menu-button').hide();

    // Reset scenario companies
    $('.scenario-companies-container').hide();
    $('.search-companies-button.selected').removeClass('selected');

    // Add empty text to Edit Details page
    parent.find('.scenario-editor-item-container').html('<div class="font-bold margin-left-5 light-grey margin-top-2">' +
        'Select an item in the Editor to display its details here</div>');
    parent.find('.scenario-editor-item-buttons-container').hide();

    // Select company details button
    if (!indies) {
        $('.scenario-editor-menu-button[data-value="company-details"]').trigger('click');
    }
}

function loadScenarioEditorChangesMadePage(scenarioData, originalScenarioData) {
    let parent = $('.scenario-editor-container');

    // Set current page
    parent.data('previousPage', 'mainPage');

    // Unselect menu buttons
    $('.scenario-editor-menu-button.selected').removeClass('selected');

    // Add headers
    let scenarioNameHtml = getScenarioNameHtml(scenarioData);
    parent.find('.scenario-editor-first-header').html(scenarioNameHtml);
    parent.find('.scenario-editor-second-header').text('Changes Made').hide().fadeIn();

    // Hide menu buttons
    parent.find('.scenario-editor-main-menu-container').hide();
    parent.find('.scenario-editor-companies-menu-container, .scenario-editor-companies-header').hide();
    parent.find('.scenario-editor-company-menu-container, .scenario-editor-indies-menu-container').hide();

    // Get and show list html
    let listContainerHtml = getScenarioEditorChangesMadeHtml(scenarioData, originalScenarioData);
    parent.find('.scenario-editor-list-container').html(listContainerHtml).fadeIn();
    parent.find('.scenario-editor-list-container').scrollTop(0);
    parent.find('.scenario-editor-list-buttons-container, .scenario-editor-list-menu-container').hide();

    // Show/hide bottom buttons
    parent.find('.scenario-editor-publish-button').hide();
    parent.find('.scenario-editor-back-button').show();
    parent.find('.scenario-editor-main-menu-button').hide();

    // Reset scenario companies
    $('.scenario-companies-container').hide();
    $('.search-companies-button.selected').removeClass('selected');

    // Add empty text to Edit Details page
    parent.find('.scenario-editor-item-container').html('<div class="font-bold margin-left-5 light-grey ' + 'margin-top-2">Select an item in the Editor to display its details here</div>');
    parent.find('.scenario-editor-item-buttons-container').hide();
}

function getScenarioEditorChangesMadeHtml(newScenarioData, oldScenarioData) {
    // Get change items
    let changeItems = getScenarioEditorChangeItems(newScenarioData, oldScenarioData);

    // Get list items html
    let itemsHtml = '';
    changeItems.forEach(function (item) {
        let itemHtml = getScenarioEditorChangeItemHtml(item);
        itemsHtml += itemHtml;
    });

    // Add empty text if no change items found
    if (changeItems.length <= 0) {
        itemsHtml += '<div class="inner-box-item scenario-editor-list-item disabled light-grey">No changes made</div>';
    }

    return itemsHtml;
}

function getScenarioEditorChangeItems(newScenarioData, oldScenarioData) {
    let changeItems = [];

    // Get changes between new and old scenario data
    getScenarioEditorChangesForObject(newScenarioData, oldScenarioData);

    function getScenarioEditorChangesForObject(newScenarioObject, oldScenarioObject, companyName) {
        Object.keys(newScenarioObject).forEach(function (objectKey) {

            // Get new objects
            let newObjects = newScenarioObject[objectKey];
            if (['scenario_details', 'indies', 'company_details'].indexOf(objectKey) >= 0) {
                // Convert certain objects to array
                newObjects = [newObjects];
                if (objectKey === 'indies') {
                    companyName = 'Indies'
                }
            }

            // Go through new objects
            newObjects.forEach(function (newObject) {
                // Set company name when going through company
                if (objectKey === 'companies') {
                    companyName = newObject.company_details.name
                }
                processScenarioEditorNewObject(newObject, oldScenarioObject, objectKey, companyName)
            });

            // Check for removed objects
            processRemovedObjects(newObjects, oldScenarioObject, objectKey, companyName);
        });
    }

    function processScenarioEditorNewObject(newObject, oldScenarioObject, objectKey, companyName) {
        // Get old object
        let oldObject = getScenarioEditorOldObject(newObject, oldScenarioObject, objectKey);
        if (oldObject) {
            // Go through keys for parent object (company, indies)
            if (objectKey === 'companies' || objectKey === 'indies') {
                getScenarioEditorChangesForObject(newObject, oldObject, companyName)
            }
            // Get changes for item (superstars, teams etc)
            else {
                getScenarioEditorItemChanges(newObject, oldObject, objectKey);
            }
        }
        else {
            // Add 'add' change item
            let objectCompanyName = (objectKey !== 'companies') ? companyName : '';  // Don't add companyName for companies
            let changeItem = createScenarioChangeItem(getScenarioEditorObjectName(newObject, objectKey), 'add',
                getObjectType(objectKey), objectCompanyName);
            changeItems.push(changeItem);
        }
    }

    function getScenarioEditorOldObject(newObject, oldScenarioObject, objectKey) {
        let oldObject;

        // Get object by key
        if (['scenario_details', 'indies', 'company_details'].indexOf(objectKey) >= 0) {
            oldObject = oldScenarioObject[objectKey]
        }
        // Get object from array by uid
        else {
            let indexArray = Array.from(oldScenarioObject[objectKey], function (x) {
                return getScenarioEditorObjectUid(x, objectKey)
            });
            oldObject = oldScenarioObject[objectKey][indexArray.indexOf(getScenarioEditorObjectUid(newObject, objectKey))];
        }

        return oldObject;
    }

    function getScenarioEditorItemChanges(newObject, oldObject, objectKey) {

        // Go through new object's properties and check for changes
        Object.keys(newObject).forEach(function (attributeKey) {

            // Skip streak name changes
            if (objectKey === 'streaks' && attributeKey === 'name') {
                return
            }

            // Check for changes between new value and old value
            let newValue = newObject[attributeKey];
            let oldValue = oldObject[attributeKey];
            let changeCheck = scenarioEditorItemChangeCheck(newValue, oldValue);
            if (changeCheck && attributeKey !== 'comments') { // Don't add change for comments
                // Add 'update' change item
                let changeItem = createScenarioChangeItem(newObject.name, 'update', null, null,
                    attributeKey, newValue, oldValue);
                changeItems.push(changeItem);
            }

        });
    }

    function scenarioEditorItemChangeCheck(newValue, oldValue) {
        // Check for changes in an object's property
        let changeCheck = false;
        if (oldValue !== undefined) {
            // Array or object type
            if (newValue instanceof Array || (typeof newValue === 'object' && newValue !== null)) {
                // Compare graphics using its own function
                if (newValue.hasOwnProperty('body') || newValue.hasOwnProperty('strap')) {
                    changeCheck = !checkGraphicsDifference(newValue, oldValue)
                }
                else {
                    changeCheck = JSON.stringify(newValue) !== JSON.stringify(oldValue);
                }
            }
            // Other type
            else {
                changeCheck = newValue !== oldValue
            }
        }
        return changeCheck;
    }

    function checkGraphicsDifference() {
        let i, l, leftChain, rightChain;

        function compare2Objects(x, y) {
            let p;
            if (y === null && x !== null) {
                return false;
            }
            for (p in x) {
                if (y.hasOwnProperty(p) !== x.hasOwnProperty(p)) {
                    return false;
                } else if (typeof y[p] !== typeof x[p]) {
                    return false;
                }

                switch (typeof (x[p])) {
                    case 'object':
                        leftChain.push(x);
                        rightChain.push(y);

                        if (!compare2Objects(x[p], y[p])) {
                            return false;
                        }

                        leftChain.pop();
                        rightChain.pop();
                        break;

                    default:
                        if (x[p] !== y[p]) {
                            return false;
                        }
                        break;
                }
            }

            return true;
        }

        for (i = 1, l = arguments.length; i < l; i++) {
            leftChain = [];
            rightChain = [];
            if (!compare2Objects(arguments[0], arguments[i])) {
                return false;
            }
        }

        return true;
    }

    function processRemovedObjects(newObjects, oldScenarioObject, objectKey, companyName) {
        let oldObjects = oldScenarioObject[objectKey];
        // Check arrays
        if (oldObjects instanceof Array) {
            let removedObjects = getArrayDifference(oldObjects, newObjects, objectKey);
            removedObjects.forEach(function (removedObject) {
                // Add 'remove' change item
                let objectCompanyName = (objectKey !== 'companies') ? companyName : '';
                let changeItem = createScenarioChangeItem(getScenarioEditorObjectName(removedObject, objectKey),
                    'remove', getObjectType(objectKey), objectCompanyName);
                changeItems.push(changeItem);
            });
        }
    }

    function getObjectType(objectKey) {
        switch (objectKey) {
            case 'superstars':
                return 'Superstar'
            case 'teams':
                return 'Team'
            case 'factions':
                return 'Faction'
            case 'events':
                return 'Event'
            case 'championships':
                return 'Championships'
            case 'gimmick_matches':
                return 'Gimmick Match'
            case 'brands':
                return 'Brand'
            case 'match_contracts':
                return 'Match Contract'
            case 'streaks':
                return 'Streak'
            case 'companies':
                return 'Company'
        }
    }

    // Sort change items by type
    changeItems.sort(function (a, b) {
        return a.type > b.type;
    });

    return changeItems;
}

function getScenarioEditorChangeItemHtml(changeItem) {
    let itemHtml = '';

    let itemClasses = 'inner-box-item scenario-editor-list-item disabled ' + changeItem.type;
    if (changeItem.type === 'update') {
        let newValue = getScenarioEditorChangeItemNewValueHtml(changeItem);
        let attributeName = getScenarioEditorChangeItemAttribute(changeItem.attribute);
        let changeDetailsHtml = '<span class="margin-left-5 grey">{0} {1}</span>'.format(attributeName, newValue);
        itemHtml += '<div class="' + itemClasses + '">{0} {1}</div>'.format(escapeHTML(changeItem.name), changeDetailsHtml);
    }
    else if (changeItem.type === 'add' || changeItem.type === 'remove') {
        let objectCompany = (changeItem.objectCompany) ? '({0})'.format(escapeHTML(changeItem.objectCompany)) : '';
        let objectDetails = '<span class="margin-left-5 grey">{0} {1}</span>'.format(changeItem.objectType, objectCompany);
        if (changeItem.type === 'add') {
            itemHtml += '<div class="' + itemClasses + '">Added {0} {1}</div>'.format(escapeHTML(changeItem.name), objectDetails);
        }
        else {
            itemHtml += '<div class="' + itemClasses + '">Removed {0} {1}</div>'.format(escapeHTML(changeItem.name), objectDetails);
        }
    }

    return itemHtml;
}

function getScenarioEditorChangeItemNewValueHtml(changeItem) {
    let changeHtml = '';

    // Don't show for specific attributes
    if (['graphic', 'name', 'description', 'color'].indexOf(changeItem.attribute) < 0) {
        let newValueHtml = getScenarioEditorChangeItemValue(changeItem.newValue, changeItem.attribute);
        changeHtml = '({0})'.format(newValueHtml);
    }

    return changeHtml;
}

function getScenarioEditorChangeItemValue(value, attribute) {
    // Null value
    if (value === null) {
        return 'None'
    }
    // Alignment specific value
    else if (attribute === 'alignment' && value === '') {
        return 'Neutral'
    }
    // Gimmick value
    else if (attribute === 'gimmick') {
        return '{0} - {1}'.format(escapeHTML(value['name']), value['effectiveness'])
    }
    // Array values
    else if (['superstars', 'managed_talent_names', 'traits'].indexOf(attribute) >= 0) {
        if (!value.length) {
            return 'None'
        }
        return value.join(', ')
    }
    // Text inputs
    else if (['weekly_show_before_name', 'weekly_show_after_name', 'weekly_show_name', 'owner_name',
        'contract_name'].indexOf(attribute) >= 0) {
        if (value === '') {
            return 'None'
        }
        return value
    }
    // Other (number, select, checkbox etc)
    else {
        if (value === parseInt(value)) {
            return parseInt(value)
        }
        return capitalizeFirstLettersOfWords(value.toString().replace(/-/g, ' ').replace(/_/g, ' '))
    }
}

function getScenarioEditorChangeItemAttribute(attribute) {
    // Format attribute name
    let attributeName;
    switch (attribute) {
        case 'full_time_manager':
            attributeName = 'Full-time Manager'
            break;
        case 'injured':
            attributeName = 'Injured Months'
            break;
        case 'managed_talent_names':
            attributeName = 'Managed Talent'
            break;
        case 'weekly_show_is_exclusive':
            attributeName = 'Exclusive Weekly Show'
            break;
        default:
            attributeName = attribute;
    }
    return toTitleCase(attributeName.replace(/_/g, ' '))
}

function createScenarioChangeItem(name, type, objectType, objectCompany, attribute, newValue, oldValue) {
    let changeItem = {};

    changeItem.name = name;
    changeItem.type = type;
    changeItem.attribute = attribute;
    changeItem.newValue = newValue;
    changeItem.oldValue = oldValue;
    changeItem.objectType = objectType;
    changeItem.objectCompany = objectCompany;

    return changeItem;
}

function getArrayDifference(array1, array2, objectKey) {
    return array1.filter(function (x) {
        let id1 = getScenarioEditorObjectUid(x, objectKey);
        return !array2.some(function (y) {
            let id2 = getScenarioEditorObjectUid(y, objectKey);
            return id2 === id1
        })
    });
}

function compareObjectNames(a, b) {
    if (a.name < b.name) {
        return -1;
    }
    if (a.name > b.name) {
        return 1;
    }
    return 0;
}

function getScenarioEditorObjectUid(object, objectKey) {
    return (objectKey === 'companies') ? object.company_details.uid : object.uid
}

function getScenarioEditorObjectName(object, objectKey) {
    return (objectKey === 'companies') ? object.company_details.name : object.name
}

function processScenarioEditorItemGraphic() {
    let scenarioEditorItemContainer = $('.scenario-editor-item-container');
    if (scenarioEditorItemContainer.find('.character-creator:visible').length > 0) {
        // Trigger share to get graphic code
        scenarioEditorItemContainer.find('.share-character').trigger('click');
        let characterData = scenarioEditorItemContainer.find('.share-character-code-input').val();
        if (characterData) {
            // Set graphic input value and trigger to update attribute
            $('.scenario-editor-graphic-input').val(characterData).trigger('change');
        }
    }
}

function loadScenarioEditorListPage(companyData, itemType) {
    let parent = $('.scenario-editor-container');
    let indies = $('.scenario-editor-container').data('indies');

    // Set current page
    parent.data('previousPage', 'companyPage');

    // Add headers
    let companyName = (indies) ? 'Indies' : '{0} <span class="grey margin-left-2">Company</span>'.format(
        escapeHTML(companyData['company_details']['name']));
    parent.find('.scenario-editor-first-header').html(companyName);
    parent.find('.scenario-editor-second-header').text(toTitleCase(itemType.replace(/-/g, ' '))).hide().fadeIn();

    // Hide menu buttons
    parent.find('.scenario-editor-main-menu-container').hide();
    parent.find('.scenario-editor-companies-menu-container, .scenario-editor-companies-header').hide();
    parent.find('.scenario-editor-company-menu-container, .scenario-editor-indies-menu-container').hide();

    // Get and show list html
    let listContainerHtml = getScenarioEditorListHtml(companyData, itemType, indies);
    parent.find('.scenario-editor-list-container').html(listContainerHtml).fadeIn();
    parent.find('.scenario-editor-list-container').scrollTop(0);

    // Show list menu
    parent.find('.scenario-editor-list-menu-container').fadeIn();
    parent.find('.scenario-editor-list-search-input').val('');
    parent.find('.scenario-editor-add-5-items-button').hide();
    parent.find('.scenario-editor-list-buttons-container, .search-companies-button').hide();
    parent.find('.scenario-editor-list-filters-container').hide();
    if (itemType === 'superstars') {
        parent.find('.scenario-editor-add-5-items-button').show();
    }
    if (itemType !== 'events') {
        parent.find('.scenario-editor-list-buttons-container').fadeIn();
    }

    // Show hide bottom buttons
    parent.find('.scenario-editor-publish-button').hide();
    parent.find('.scenario-editor-back-button, .scenario-editor-main-menu-button').show();

    // Add empty text to Edit Details page
    parent.find('.scenario-editor-item-container').html('<div class="font-bold margin-left-5 light-grey margin-top-2">' +
        'Select an item in the Editor to display its details here</div>');
    parent.find('.scenario-editor-item-buttons-container').hide();
}

function getScenarioEditorListHtml(companyData, itemType, indies) {
    // Get objects
    let itemObjects = getScenarioEditorItemObjects(companyData, itemType);

    // Get list items html
    let itemsHtml = '';
    itemObjects.forEach(function (item) {
        let itemHtml = getScenarioEditorListItemHtml(item, itemType, indies);
        itemsHtml += itemHtml;
    });

    // Add empty text if no itemObjects found
    if (itemObjects.length <= 0) {
        itemsHtml += '<div class="inner-box-item scenario-editor-list-item disabled light-grey none-text">No ' +
            itemType.replace(/-/g, ' ') + ' present</div>';
    }

    return itemsHtml;
}

function getScenarioEditorListItemHtml(item, itemType, indies) {

    // Training/future superstars name highlight
    let trainingClass = '';
    let futureClass = '';
    if (itemType === 'superstars' && item.training && !indies) {
        trainingClass = ' training';
    }
    if (itemType === 'superstars' && item.month_to_appear_in) {
        futureClass = ' future';
    }

    // Trio class
    let trioClass = '';
    if (itemType === 'teams' && item.team_type === 'trio') {
        trioClass = ' trio';
    }

    // Name
    let name = '<span class="scenario-editor-list-item-name' + trainingClass + futureClass + '">' +
        escapeHTML(item['name']) + '</span>';

    // Get html
    return '<div class="inner-box-item scenario-editor-list-item' + trainingClass + trioClass + '" data-uid="' +
        item['uid'] + '">' +
        '<div>' +
        name +
        '</div>' +
        '</div>';
}

function validateScenarioEditorValue(value, attribute, element) {
    let validationCheck = {};

    // Check if 'name' is present
    if (attribute === 'name') {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter a name for this item'
        }
    }
    // Check if 'comments' is present
    if (attribute === 'comments' && element.attr('data-edit-name')) {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter a name for this Scenario Edit'
        }
    }
    // Check 'age'
    if (attribute === 'age') {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter an age for this superstar'
        }
        else if (value < 10 || value > 100) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter an age between 10 and 100'
        }
    }
    // Check 'popularity'
    if (attribute === 'popularity') {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter a popularity for this superstar'
        }
        else if (value < 0 || value > 1050) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter a popularity 0 and 1050'
        }
    }
    // Check months for 'injury'
    if (attribute === 'injured') {
        if (element.hasClass('scenario-editor-injured-months-input')) {
            if (value < 0 || value > 120) {
                validationCheck.error = true;
                validationCheck.message = 'Please enter injury months between 0 and 120'
            }
        }
    }
    // Check month and year for 'month_to_appear_in'
    if (attribute === 'month_to_appear_in') {
        if (element.hasClass('scenario-editor-month-input')) {
            let months = $('.scenario-editor-month-input').val();
            if (months < 0 || months > 11) {
                validationCheck.error = true;
                validationCheck.message = 'Please enter future months between 0 and 11'
            }
        }
        if (element.hasClass('scenario-editor-year-input')) {
            let years = $('.scenario-editor-year-input').val();
            if (years < 0 || years > 200) {
                validationCheck.error = true;
                validationCheck.message = 'Please enter future years between 0 and 200'
            }
        }
    }
    // Check 'starting_year'
    if (attribute === 'starting_year') {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter a starting year'
        }
        else if (value < 0 || value > 1000000) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter a starting year between 0 and 1,000,000'
        }
    }
    // Check 'reputation'
    if (attribute === 'reputation') {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter a reputation'
        }
        else if (value < 1 || value > 10) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter a reputation between 1 and 10'
        }
    }
    // Check 'creative_points'
    if (attribute === 'creative_points') {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter creative points'
        }
        else if (value < 0 || value > 5000) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter creative points between 0 and 5000'
        }
    }
    // Check 'length'
    if (attribute === 'length') {
        if (!value) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter a length in years'
        }
        else if (value < 1 || value > 100) {
            validationCheck.error = true;
            validationCheck.message = 'Please enter a length in years between 1 and 100'
        }
    }

    return validationCheck;
}

function updateScenarioEditorObject(object, value, attribute, itemType) {
    // Update attribute
    object[attribute] = value;

    // Update displayed name
    if (attribute === 'name') {
        updateScenarioEditorObjectDisplayedName(object, value, itemType);
    }

    // Update streak's displayed name and object attribute
    if (itemType === 'streaks' && (attribute === 'event' || attribute === 'talent')) {
        let streakTalent = $('.scenario-editor-talent-select').val();
        let streakEvent = $('.scenario-editor-event-select').val();
        let streakName = getScenarioEditorStreakName(streakTalent, streakEvent);
        $('.scenario-editor-list-item[data-uid="' + object.uid + '"]').find('.scenario-editor-list-item-name').text(streakName);
        object.name = streakName;
    }
}

function updateScenarioEditorObjectDisplayedName(object, value, itemType) {
    // Update scenario/company name in header
    if (itemType === 'scenario-details') {
        $('.scenario-editor-first-header').html('{0} <span class="grey margin-left-2">Scenario</span>'.format(escapeHTML(value)));
    } else if (itemType === 'company-details') {
        $('.scenario-editor-first-header').html('{0} <span class="grey margin-left-2">Company</span>'.format(escapeHTML(value)));
    }
    // Update name in list container
    else {
        $('.scenario-editor-list-item[data-uid="' + object.uid + '"]').find('.scenario-editor-list-item-name').text(value);
    }
}

function getScenarioEditorStreakName(streakTalent, streakEvent) {
    let streakName;
    if (streakTalent && streakEvent) {
        streakName = '{0} ({1})'.format(streakTalent, streakEvent)
    }
    else {
        streakName = streakTalent || streakEvent
    }
    return streakName;
}

function updateScenarioEditorObjectLinks(object, value, itemType, companyData, scenarioData) {
    // Update object's links if any found with same name
    let numberOfLinksUpdated = 0;

    function updateObjectLink(objectToUpdate, attribute, index) {
        // Update array value
        if (index !== undefined) {
            objectToUpdate[attribute][index] = value
        }
        // Update property
        else {
            objectToUpdate[attribute] = value;
        }
        numberOfLinksUpdated += 1;
    }

    // Superstars
    if (itemType === 'superstars') {
        companyData.superstars.forEach(function(superstar) {
           superstar.managed_talent_names.forEach(function(managedSuperstar, i) {
              if (managedSuperstar === object.name) {
                  updateObjectLink(superstar, 'managed_talent_names', i);
              }
           });
        });
        companyData.teams.forEach(function (team) {
            team.superstars.forEach(function (teamSuperstar, i) {
                if (teamSuperstar === object.name) {
                    updateObjectLink(team, 'superstars', i);
                }
            });
        });
        // Don't run for indies
        if (companyData.factions) {
            companyData.factions.forEach(function (faction) {
                faction.superstars.forEach(function (factionSuperstar, i) {
                    if (factionSuperstar === object.name) {
                        updateObjectLink(faction, 'superstars', i);
                    }
                });
                if (faction.leader_superstar === object.name) {
                    updateObjectLink(faction, 'leader_superstar');
                }
            });
            companyData.championships.forEach(function (championship) {
                if (championship.champion === object.name) {
                    updateObjectLink(championship, 'champion');
                }
            });
            companyData.streaks.forEach(function (streak) {
                if (streak.talent === object.name) {
                    updateObjectLink(streak, 'talent');
                    streak.name = getScenarioEditorStreakName(streak.talent, streak.event); // Update streak name
                }
            });
            companyData.match_contracts.forEach(function (matchContract) {
                if (matchContract.talent === object.name) {
                    updateObjectLink(matchContract, 'talent');
                }
            });
        }
    }

    // Teams
    if (itemType === 'teams') {
        companyData.superstars.forEach(function(superstar) {
           superstar.managed_talent_names.forEach(function(managedSuperstar, i) {
              if (managedSuperstar === object.name) {
                  updateObjectLink(superstar, 'managed_talent_names', i);
              }
           });
        });
        // Don't run for indies
        if (companyData.championships) {
            companyData.championships.forEach(function (championship) {
                if (championship.champion === object.name) {
                    updateObjectLink(championship, 'champion');
                }
            });
            companyData.streaks.forEach(function (streak) {
                if (streak.talent === object.name) {
                    updateObjectLink(streak, 'talent');
                    streak.name = getScenarioEditorStreakName(streak.talent, streak.event);
                }
            });
            companyData.match_contracts.forEach(function (matchContract) {
                if (matchContract.talent === object.name) {
                    updateObjectLink(matchContract, 'talent');
                }
            });
        }
    }

    // Events
    if (itemType === 'events') {
        companyData.streaks.forEach(function (streak) {
            if (streak.event === object.name) {
                updateObjectLink(streak, 'event');
                streak.name = getScenarioEditorStreakName(streak.talent, streak.event);
            }
        });
        companyData.match_contracts.forEach(function (matchContract) {
            if (matchContract.event === object.name) {
                updateObjectLink(matchContract, 'event');
            }
        });
        if (companyData.company_details.top_event === object.name) {
            updateObjectLink(companyData.company_details, 'top_event')
        }
        if (scenarioData.scenario_details.starting_event === object.name) {
            updateObjectLink(scenarioData.scenario_details, 'starting_event')
        }
    }

    // Brands
    if (itemType === 'brands') {
        let brandObjects = companyData.superstars.concat(companyData.events, companyData.championships);
        brandObjects.forEach(function (brandObject) {
            if (brandObject.brand_name === object.name) {
                updateObjectLink(brandObject, 'brand_name')
            }
        });
    }

    if (numberOfLinksUpdated) {
        notie.alert({type: 4, text: 'Item links updated ({0})'.format(numberOfLinksUpdated)});
    }
}

function checkScenarioEditorAddItemLimit(numberOfItems, itemType) {

    // Get item limit
    let itemLimit;
    let indies = $('.scenario-editor-container').data('indies');
    let suffix = indies ? ' to the Indies' : ' per company';
    switch (itemType) {
        case 'superstars':
            itemLimit = indies ? 2000 : 1250;
            break;
        case 'teams':
            itemLimit = 200;
            break;
        case 'factions':
            itemLimit = 100;
            break;
        case 'events':
            itemLimit = 12;
            break;
        case 'championships':
            itemLimit = 30;
            break;
        case 'gimmick-matches':
            itemLimit = 60;
            break;
        case 'brands':
            itemLimit = 3;
            break;
        case 'match-contracts':
            itemLimit = 20;
            break;
        case 'streaks':
            itemLimit = 100;
            break;
        case 'companies':
            itemLimit = gameLimits.maxEditorCompetitors + 1;
            suffix = '';
            break;
    }

    if (numberOfItems >= itemLimit) {
        notie.alert({type: 3, text: "You cannot add more than " + itemLimit + " " + toTitleCase(itemType.replace(/-/g, ' ')) + suffix});
        return false;
    }

    return true;
}

function moveScenarioEditorItemObject(itemObject, itemObjects, itemType, itemObjectsToMoveTo, additionalMove) {
    // Remove from itemObjects
    itemObjects.splice(itemObjects.indexOf(itemObject), 1);

    // Add to item objects to move to
    itemObjectsToMoveTo.push(itemObject);

    // Set future superstar to training (for main roster)
    if (itemObject.month_to_appear_in) {
        itemObject.training = true
    }

    if (!additionalMove) {
        // Remove item from list
        $('.scenario-editor-list-item[data-uid="' + itemObject.uid + '"]').remove();

        // Reset search/filters
        $('.scenario-editor-list-search-input').val('');
        $('.scenario-editor-list-filter.selected').removeClass('selected');
        $('.scenario-editor-list-item').show();
        $('.no-scenario-editor-search-results').hide();

        // Add empty text if no objects left
        if (itemObjects.length <= 0) {
            $('.scenario-editor-list-container').html('<div class="inner-box-item scenario-editor-list-item disabled light-grey none-text">No ' + itemType.replace(/-/g, ' ') + ' present</div>');
        }

        // Add empty text to Edit Details page
        $('.scenario-editor-item-container').html('<div class="font-bold margin-left-5 light-grey margin-top-2">Select an item in the Editor to display its details here</div>');
        $('.scenario-editor-item-buttons-container').hide();
    }
}

function checkScenarioValidation(scenarioData) {
    let validationCheck = true;
    if (scenarioData.companies.length <= 0) {
        notie.alert({type: 3, text: "You need to have at least 1 Company present in the Scenario", stay: true});
        validationCheck = false;
    }
    scenarioData.companies.forEach(function(company) {
        if (company.superstars.length < 2) {
            notie.alert({type: 3, text: "You need to have at least 2 Superstars present for each Company", stay: true});
            validationCheck = false;
        }
        // Check for duplicate event names
        let companyEventNames = Array.from(company.events, function (e) {
            return e.name
        });
        if (new Set(companyEventNames).size !== companyEventNames.length) {
            notie.alert({type: 3, text: "Please make sure all monthly event names are different from each other", stay: true});
            validationCheck = false;
        }
    })
    return validationCheck;
}

function toggleScenarioEditorItemInputsContainer(element) {
    let inputsContainerSelector;
    let highlightElement = true;
    if (element.hasClass('scenario-editor-injured-input')) {
        inputsContainerSelector = '.superstar-injured-months-container'
    }
    else if (element.hasClass('scenario-editor-gimmick-input')) {
        inputsContainerSelector = '.superstar-gimmick-container'
    }
    else if (element.hasClass('scenario-editor-manager-input')) {
        inputsContainerSelector = '.superstar-manager-container'
    }
    else if (element.hasClass('scenario-editor-training-input')) {
        inputsContainerSelector = '.superstar-future-container';
        // Enable/disable brand select, training name highlight
        if (element.prop('checked') === true) {
            // Disable brand select and set value to None
            $('.scenario-editor-brand-select').val('None').trigger('change').prop('disabled', true).addClass('light-opaque');
            // Show training name highlight
            $('.scenario-editor-list-item.selected .scenario-editor-list-item-name').addClass('training');
            $('.scenario-editor-list-item.selected').addClass('training');
        }
        else {
            // Enable brand select
            $('.scenario-editor-brand-select').prop('disabled', false).removeClass('light-opaque');
            // Hide training name highlight
            $('.scenario-editor-list-item.selected .scenario-editor-list-item-name').removeClass('training');
            $('.scenario-editor-list-item.selected').removeClass('training');
            // Remove month_to_appear_in
            $('.scenario-editor-month-input').val('');
            $('.scenario-editor-year-input').val('').trigger('change');
        }
    }
    else if (element.hasClass('scenario-editor-future-input')) {
        inputsContainerSelector = '.superstar-future-inputs-container';
        if (element.closest('.superstar-future-container').siblings('label').length > 0) {
            highlightElement = false;
        }
    }

    if (element.prop('checked') === true) {
        if (highlightElement) {
            element.parent().addClass('faded-blue')
        }
        element.parent().siblings(inputsContainerSelector).removeClass('display-none');
    }
    else {
        if (highlightElement) {
            element.parent().removeClass('faded-blue')
        }
        element.parent().siblings(inputsContainerSelector).addClass('display-none');
    }
}

function toggleScenarioEditorTeamTypeInput(element) {
    let val = element.val();
    if (val === 'trio') {
        element.closest('.scenario-editor-item-container').find('.scenario-editor-third-superstar-select').parent().removeClass('display-none');
        $('.scenario-editor-list-item.selected').addClass('trio');
    }
    else {
        element.closest('.scenario-editor-item-container').find('.scenario-editor-third-superstar-select').parent().addClass('display-none');
        $('.scenario-editor-list-item.selected').removeClass('trio');
    }
}

function toggleScenarioEditorConsequenceInput(element) {
    let val = element.val();
    if (val === 'championship_contract' || val === 'match_contract') {
        element.parent().siblings('.scenario-editor-contract-name-container').removeClass('display-none');
    }
    else {
        element.parent().siblings('.scenario-editor-contract-name-container').addClass('display-none');
        // Remove contract_name
        $('.scenario-editor-contract-name-input').val('').trigger('change');
    }
}

function getScenarioEditorItemInputValue(element, attribute, itemType) {

    // Get input/checked value
    let value = element.val().trim();
    if (element.attr('type') === 'checkbox') {
        value = element.prop('checked');
    }

    // Get integer value of number input
    if ((element.attr('type') === 'number' && value) || ['market_size', 'charisma', 'workrate', 'rating_boost',
        'injury_rate'].indexOf(attribute) >= 0) {
        value = parseInt(value)
    }

    // Get specific value based on attribute

    // Superstars
    if (attribute === 'gimmick') {
        if ($('.scenario-editor-gimmick-input').prop('checked')) {
            let gimmickName = $('.scenario-editor-gimmick-name-input').val();
            if (gimmickName) {
                value = {'name': gimmickName, 'effectiveness': $('.scenario-editor-gimmick-effectiveness-select').val()}
            }
            else {
                value = null
            }
        }
        else {
            value = null
        }
    }

    if (attribute === 'injured') {
        if ($('.scenario-editor-injured-input').prop('checked')) {
            value = ($('.scenario-editor-injured-months-input').val()) ? parseInt($('.scenario-editor-injured-months-input').val()) : 0;
        }
        else {
            value = 0
        }
    }

    if (attribute === 'managed_talent_names') {
        if ($('.scenario-editor-manager-input').prop('checked')) {
            // Don't get None values
            let talentSelects = $('.scenario-editor-managed-talent-select').filter(function (i, x) {
                return $(x).find(':selected').attr('data-uid');
            });
            value = Array.from(talentSelects, function (el) {
                return $(el).val();
            });
        }
        else {
            value = []
        }
    }

    if (attribute === 'month_to_appear_in') {
        if ($('.scenario-editor-future-input').prop('checked')) {
            let month = ($('.scenario-editor-month-input').val()) ? parseInt($('.scenario-editor-month-input').val()) : 0;
            let year = ($('.scenario-editor-year-input').val()) ? parseInt($('.scenario-editor-year-input').val()) : 0;
            if (month || year) {
                value = (year * 12) + month;
                $('.scenario-editor-list-item.selected .scenario-editor-list-item-name').addClass('future');
            }
            else {
                value = null;
                $('.scenario-editor-list-item.selected .scenario-editor-list-item-name').removeClass('future');
            }
        }
        else {
            value = null;
            $('.scenario-editor-list-item.selected .scenario-editor-list-item-name').removeClass('future');
        }
    }

    if (attribute === 'brand_name') {
        let brandOption = $('.scenario-editor-brand-select').find(':selected');
        if (brandOption.attr('data-uid')) {
            value = brandOption.val()
        }
        else {
            value = null
        }
    }

    if (attribute === 'traits') {
        if (value) {
            value = value.split(', ')
        }
        else {
            value = []
        }
    }

    if (attribute === 'graphic') {
        if (value) {
            value = JSON.parse(value)
        }
        else {
            value = null;
        }
    }

    // Teams
    if (itemType === 'teams' && attribute === 'superstars') {
        value = [$('.scenario-editor-first-superstar-select').val(), $('.scenario-editor-second-superstar-select').val()];
        if ($('.scenario-editor-team-type-select').val() === 'trio') {
            value.push($('.scenario-editor-third-superstar-select').val())
        }
    }

    // Factions
    if (attribute === 'leader_superstar') {
        let factionLeaderOption = $('.scenario-editor-faction-leader-select').find(':selected');
        if (factionLeaderOption.attr('data-uid')) {
            value = factionLeaderOption.val()
        }
        else {
            value = null
        }
    }

    if (itemType === 'factions' && attribute === 'superstars') {
        // Don't get None values
        let talentSelects = $('.scenario-editor-faction-member-select').filter(function (i, x) {
            return $(x).find(':selected').attr('data-uid');
        });
        value = Array.from(talentSelects, function (el) {
            return $(el).val();
        });
    }

    // Championships
    if (attribute === 'champion') {
        let championOption = $('.scenario-editor-champion-select').find(':selected');
        if (championOption.attr('data-uid')) {
            value = championOption.val()
        }
        else {
            value = null
        }
    }

    // Gimmick Matches
    if (attribute === 'consequence' || attribute === 'rules' || attribute === 'contract_name' ||
        attribute === 'graphic_type') {
        if (!value) {
            value = null
        }
    }

    return value;
}

function capitalizeFirstLettersOfWords(str) {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substring(1);
    });
}

function runScenarioEditorListSearch() {

    let listContainer = $('.scenario-editor-list-container');
    let listElements = document.querySelectorAll('.scenario-editor-list-item:not(.no-scenario-editor-search-results)');
    let searchTerm = $(".scenario-editor-list-search-input").val();

    for (let i = 0; i < listElements.length; i++) {
        listElements[i].style.display = "none";
    }

    // Run search
    if (searchTerm.length > 0) {
        let searchResults = runFuseElementsSearch(listElements, searchTerm, ['textContent']);
        // Show results if found
        if (searchResults.length > 0) {
            searchResults.forEach(function (e) {
                e.style.display = "block";
            });
            $('.no-scenario-editor-search-results').hide();
        }
        else {
            if ($('.no-scenario-editor-search-results').length > 0) {
                $('.no-scenario-editor-search-results').show()
            }
            else {
                listContainer.append('<div class="no-scenario-editor-search-results inner-box-item ' +
                    'scenario-editor-list-item disabled light-grey">No results found</div>')
            }
        }
    }
    else {
        for (let i = 0; i < listElements.length; i++) {
            listElements[i].style.display = "block";
        }
        $('.no-scenario-editor-search-results').hide();
    }

    // Remove filters
    $('.scenario-editor-list-filter.selected').removeClass('selected');

    listContainer.scrollTop(0);
}

function loadEditScenarioDataRequest(uid, version, scenarioType, duplicate) {
    if (globals.requestRunning) {
        return false;
    }

    makeGetRequest('/_get_edit_scenario_data', {
        uid: uid, version: version, scenarioType: scenarioType,
        duplicate: duplicate, job: true
    }, async (data) => {
        if (!data['error']) {
            await checkGetEditScenarioDataJob(data['statusUrl'], scenarioType);
        }
        else {
            notie.hideAlerts();
            globals.requestRunning = false;
            playSoundEffect('error');
            if (data['error'] === 'does-not-belong-to-user') {
                notie.alert({type: 3, text: "This scenario is not available for you to edit."});
            }
        }
    }, true, 'Please wait, this can take some time, depending on the size of the scenario.');
}

async function checkGetEditScenarioDataJob(statusUrl, scenarioType) {
    makeGetRequest(statusUrl, {}, async (data) => {
        switch (data.status) {
            case "unknown":
            case "failed":
                notie.hideAlerts();
                globals.requestRunning = false;

                notie.alert({type: 3, text: "There was an error. Please try again"});
                break;
            case "finished":
                notie.hideAlerts();
                globals.requestRunning = false;

                // Don't load edit if html tags found
                if (scenarioType === 'scenario_edit') {
                    const regex = /(<[^>]*>)|(&lt;)|(\/script)|(src=)|(&#)|(onfocus=)/i;
                    const regexResult = JSON.stringify(data['result']).match(regex);
                    if (regexResult) {
                        notie.alert({
                            type: 3,
                            text: "HTML tags were found within the scenario. For security purposes, the scenario wasn't loaded."
                        })
                        return false;
                    }
                }

                playSoundEffect('success');

                hideMainMenuContent($());

                // Load scenarioData
                scenarioData = data['result'];

                // Add scenario type
                scenarioData.scenario_details.scenario_type = scenarioType;

                // Copy original scenario data
                originalScenarioData = JSON.parse(JSON.stringify(scenarioData));

                // Load main page
                loadScenarioEditorMainPage(scenarioData);

                if (scenarioEditorInfoShown) {
                    $('.scenario-editor-container').fadeIn('slow');
                }
                else {
                    $('.scenario-editor-info-container').hide().fadeIn();
                    scenarioEditorInfoShown = true;
                }

                break;
            default:
                setTimeout(async function () {
                    await checkGetEditScenarioDataJob(statusUrl, scenarioType);
                }, 1000);
        }
    }, true, null, false);
}

async function addScenarioDataRequest(scenarioData) {
    if (globals.requestRunning) {
        return false;
    }
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>' +
            'Please wait, this can take some time, depending on the size of the scenario.', stay: true});
    globals.requestRunning = true;

    // Compress
    const scenarioDataArrayBuffer = fflate.strToU8(JSON.stringify(scenarioData));
    fflate.zlib(scenarioDataArrayBuffer, (err, compressed) => {  // use zlib as backend uses zlib for decompression
        if (err) {
            notie.alert({
                type: 3, text: 'Add scenario compression failed.'
            });
            captureError(new Error('error for add scenario compression: ' + err));
            return;
        }
        $.ajax({
            type: "POST",
            contentType: 'application/octet-stream',
            url: globals.baseUrl + '/_add_scenario_data',
            data: compressed,
            success: async function (data, status, request) {
                if (!data['error']) {
                    let statusUrl = request.getResponseHeader('Location');
                    await checkAddScenarioDataJob(statusUrl, scenarioData);
                }
                else {
                    globals.requestRunning = false;
                    if (data['error'] === 'not-logged-in') {
                        notie.alert({type: 3, text: "You need to login to create a Scenario", stay: true});
                    }
                    else if (data['error'] === 'not-paid') {
                        notie.alert({type: 3, text: "You need to have JoW Paid to create edits", stay: true});
                    }
                    else if (data['error'] === 'edits-not-allowed') {
                        notie.alert({
                            type: 3,
                            text: "The scenario creator has disabled Edits for this Scenario",
                            stay: true
                        });
                    }
                    else if (data['error'] === 'incorrect-user') {
                        notie.alert({type: 3, text: "This scenario does not belong to you", stay: true});
                    }
                    else if (data['error'] === 'html-present') {
                        notie.alert({
                            type: 3,
                            text: "HTML tags were found within your scenario. Please remove them and try again.",
                            stay: true
                        });
                    }
                    else {
                        notie.alert({
                            type: 3,
                            text: 'An error occurred while adding the scenario. Please try again.',
                            stay: true
                        });
                    }
                }
            },
            processData: false,
            timeout: requestTimeout,
            error: function (jqXHR, status, errorThrown) {
                globals.requestRunning = false;

                if (!window.navigator.onLine) {
                    notie.alert({
                        type: 3,
                        text: 'It seems like you\'re offline. Please check your internet connection and try again.'
                    });
                }
                else {
                    if (status === 'timeout') {
                        notie.alert({
                            type: 3,
                            text: 'The add scenario request timed out. Please try again in a while.'
                        });
                    }
                    else {
                        notie.alert({
                            type: 3,
                            text: 'There was an error with the add scenario request. Please try again.'
                        });
                    }
                    captureError(new Error('error for add scenario request: ' + errorThrown));
                }
            }
        });
    });
}

async function checkAddScenarioDataJob(statusUrl, scenarioData) {
    makeGetRequest(statusUrl, {}, async (data) => {
        switch (data.status) {
            case "unknown":
            case "failed":
                globals.requestRunning = false;
                notie.alert({type: 3, text: "There was an error adding the scenario. Please try again."});
                break;
            case "finished":
                globals.requestRunning = false;
                if (!data['result']['error']) {
                    playSoundEffect('success');
                    $(".scenario-editor-container").fadeOut('fast', function () {
                        $('#main-menu-buttons').find('li').removeClass('selected');
                        $('.main-container').removeClass('blur');

                        let notieText = '';
                        if (scenarioData.scenario_details.scenario_type === 'scenario') {
                            if (scenarioData.scenario_details.version) {
                                notieText = 'Scenario update added.'
                            } else {
                                notieText = 'Scenario added. It can be found by clicking "My Scenarios" under "New Game".'
                            }
                        }
                        else if (scenarioData.scenario_details.scenario_type === 'scenario_edit') {
                            if (scenarioData.scenario_details.edit_version) {
                                notieText = 'Scenario edit update added.'
                            } else {
                                notieText = 'Scenario edit added. It can be found by clicking "Show Edits" under ' +
                                    'the scenario.'
                            }
                        }
                        notie.alert({type: 4, text: notieText, stay: true});
                    });
                }
                else {
                    playSoundEffect('error');
                    if (data['result']['error'] === 'not-logged-in') {
                        notie.alert({type: 3, text: "You need to login to create a Scenario", stay: true});
                    }
                    else if (data['result']['error'] === 'not-paid') {
                        notie.alert({type: 3, text: "You need to have JoW Paid to create edits", stay: true});
                    }
                    else if (data['result']['error'] === 'edits-not-allowed') {
                        notie.alert({
                            type: 3,
                            text: "The scenario creator has disabled Edits for this Scenario",
                            stay: true
                        });
                    }
                    else if (data['result']['error'] === 'incorrect-user') {
                        notie.alert({type: 3, text: "This scenario does not belong to you", stay: true});
                    }
                    else if (data['result']['error'] === 'html-present') {
                        notie.alert({
                            type: 3,
                            text: "HTML tags were found within your scenario. Please remove them and try again.",
                            stay: true
                        });
                    }
                    else {
                        notie.alert({
                            type: 3,
                            text: 'An error occurred while adding the scenario. Please try again.',
                            stay: true
                        });
                    }
                }
                break;
            default:
                setTimeout(async function () {
                    await checkAddScenarioDataJob(statusUrl, scenarioData);
                }, 1000);
        }
    }, true, null, false);
}

function applyScenarioEditorListFilter(filterName) {

    let listContainer = $('.scenario-editor-list-container');
    let listElements = document.querySelectorAll('.scenario-editor-list-item:not(.no-scenario-editor-search-results)');

    // Run search
    if (filterName) {
        let filterResults = [];
        if (filterName === 'main') {
            filterResults = document.querySelectorAll('.scenario-editor-list-item:not(.training):not(.no-scenario-editor-search-results)');
        }
        else if (filterName === 'training') {
            filterResults = document.querySelectorAll('.scenario-editor-list-item.training:not(.no-scenario-editor-search-results)');
        }

        for (let i = 0; i < listElements.length; i++) {
            listElements[i].style.display = "none";
        }

        // Show results if found
        if (filterResults.length > 0) {
            filterResults.forEach(function (e) {
                e.style.display = "block";
            });
            $('.no-scenario-editor-search-results').hide();
        }
        else {
            if ($('.no-scenario-editor-search-results').length > 0) {
                $('.no-scenario-editor-search-results').show()
            }
            else {
                listContainer.append('<div class="no-scenario-editor-search-results inner-box-item ' +
                    'scenario-editor-list-item disabled light-grey">No results found</div>')
            }
        }
    }
    else {
        for (let i = 0; i < listElements.length; i++) {
            listElements[i].style.display = "block";
        }
        $('.no-scenario-editor-search-results').hide();
    }

    // Reset search
    $(".scenario-editor-list-search-input").val('');

    listContainer.scrollTop(0);

}

function updateScenarioEditorFactionLeaderSelect() {
    let selectFactionMemberDivs = $('.scenario-editor-faction-member-select');
    let selectFactionLeaderDiv = $('.scenario-editor-faction-leader-select');
    let selectedValue = selectFactionLeaderDiv.val();

    // Reset
    selectFactionLeaderDiv.html('');
    selectFactionLeaderDiv.append($('<option selected>None</option>'));

    // Add faction members selected as options, don't add duplicates
    selectFactionMemberDivs.each(function(i, e) {
        let selectedOption = $(e).find('option:selected');
        if (selectedOption.attr('data-uid') && selectFactionLeaderDiv.find('option[value="' + selectedOption.val().replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1') + '"]').length <= 0) {
            selectFactionLeaderDiv.append($("<option />").val(selectedOption.val()).text(selectedOption.text()).attr('data-uid', selectedOption.attr('data-uid')))
        }
    });

    // If previously selected value found, select it, otherwise select none
    let unencodedSelectedValue = (selectedValue) ? selectedValue.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1')  : selectedValue;
    if (selectFactionLeaderDiv.find('option[value="' + unencodedSelectedValue + '"]').length > 0) {
        selectFactionLeaderDiv.val(selectedValue);
    }
    else {
        selectFactionLeaderDiv.val('None');
    }
}

function runScenarioCompaniesSearch(searchTerm, page) {
    if (globals.requestRunning) {
        return false;
    }

    makeGetRequest('/_search_scenario_companies', {name: searchTerm, page: page},
        (data) => {
            // Get search results html
            let html = '';
            data['companies'].forEach(function (item) {
                html += getScenarioCompanyItemHtml(item);
            });

            // Show empty results if no companies found
            if (data['companies'].length <= 0) {
                html = '<div class="inner-box-item scenario-companies-search-result-item disabled light-grey">' +
                    'No Companies found' +
                    '</div>';
            }

            // Show next/prev page buttons
            showScenarioCompaniesPagination(data);

            // Show results
            $('.scenario-companies-results').show();
            $('.scenario-companies-results-container').html(html).show();
            $('.scenario-companies-results-container').scrollTop(0);

            // Put focus back on search field
            $(".scenario-companies-search-input").focus();
        });
}

function showScenarioCompaniesPagination(data) {
    if (data['next_page']) {
        $('.scenario-companies-next-page-button').removeClass('visibility-hidden').data('page', data['next_page'])
    } else {
        $('.scenario-companies-next-page-button').addClass('visibility-hidden')
    }
    if (data['previous_page']) {
        $('.scenario-companies-previous-page-button').removeClass('visibility-hidden').data('page', data['previous_page'])
    } else {
        $('.scenario-companies-previous-page-button').addClass('visibility-hidden')
    }

    if (data['next_page'] || data['previous_page']) {
        $('.scenario-companies-pagination-buttons').show()
    }
    else {
        $('.scenario-companies-pagination-buttons').hide()
    }
}

function getScenarioCompanyItemHtml(item) {
    let creatorHtml = '<span class="high-light-grey margin-left-3">by {0}</span>'.format(escapeHTML(item['creator']));
    let datetimeUpdatedHtml = '';
    if (item['datetime_updated_string'] !== undefined) {
        datetimeUpdatedHtml = '<span class="high-light-grey margin-left-2">{0}</span>'.format(item['datetime_updated_string'])
    }
    let ratingHtml;
    if (item['rating'] === null) {
        ratingHtml = '<span class="rating no-rating margin-left-2">?? %</span>'
    } else {
        if (item['rating'] >= 50) {
            ratingHtml = '<span class="rating positive margin-left-2">' + item['rating'] + '%</span>'
        } else {
            ratingHtml = '<span class="rating negative margin-left-2">' + item['rating'] + '%</span>'
        }
    }
    let scenarioName = '<span class="light-grey margin-left-3">{0}</span>'.format(escapeHTML(item['scenario_name']));
    let itemInfo = '{0} {1} {2} {3} {4}'.format(escapeHTML(item['company_name']), creatorHtml, scenarioName, ratingHtml, datetimeUpdatedHtml);

    return '<div class="inner-box-item scenario-companies-search-result-item" ' +
        'data-uid="' + item['uid'] + '" data-creator="' + item['creator'].replace(/"/g, "&quot;") +
        '" data-scenario-name="' + item['scenario_name'].replace(/"/g, "&quot;") + '">' +
        '<div class="medium-dark-grey">' +
        itemInfo +
        '</div>' +
        '</div>';
}

export {createScenarioMenuButtonHandler}